/**
 * Turkish UI strings — the SOURCE language. Every key added here must also be
 * added to en.ts (the type system enforces this).
 * Placeholders use {name} syntax and are filled by t(key, vars).
 */
export const tr = {
  "app.productLabel": "Forklift Takip Sistemi",
  "app.logoAlt": "Expartise Makine",
  "app.demoBadge": "Demo · örnek veri",
  "app.demoBadgeShort": "Demo",
  "app.skipToContent": "İçeriğe geç",

  "common.loading": "Yükleniyor…",
  "common.loadError": "Veriler yüklenemedi.",
  "common.retry": "Tekrar dene",
  "common.empty": "—",
  "common.yes": "Evet",
  "common.no": "Hayır",
  "common.backToOverview": "Genel bakışa dön",

  "nav.ariaLabel": "Ana menü",
  "nav.openMenu": "Menüyü aç",
  "nav.closeMenu": "Menüyü kapat",
  "nav.overview": "Genel bakış",
  "nav.group.monitoring": "İzleme",
  "nav.liveMap": "Canlı harita",
  "nav.alarms": "Alarmlar",
  "nav.group.fleet": "Filo",
  "nav.sites": "Sahalar",
  "nav.vehicles": "Araçlar",
  "nav.devices": "Cihazlar",
  "nav.group.operators": "Operatörler",
  "nav.operators": "Operatörler",
  "nav.cards": "Kartlar",
  "nav.permissions": "Yetkiler",
  "nav.group.reports": "Raporlar",
  "nav.reportUsage": "Kullanım",
  "nav.reportEvents": "Darbe ve olaylar",
  "nav.reportRoutes": "Rota geçmişi",
  "nav.group.admin": "Yönetim",
  "nav.users": "Kullanıcılar ve roller",
  "nav.audit": "Denetim kaydı",
  "nav.settings": "Ayarlar",

  "tenant.label": "Kiracı",
  "tenant.switch": "Kiracı değiştir",
  "tenant.listLabel": "Erişebildiğiniz kiracılar",
  "tenant.platformAdmin": "Platform yöneticisi",
  "tenant.none": "Bu hesaba bağlı bir kiracı yok.",

  "role.viewer": "İzleyici",
  "role.safety": "İSG sorumlusu",
  "role.fleet_manager": "Filo yöneticisi",
  "role.admin": "Yönetici",

  "user.signOut": "Çıkış yap",
  "user.menuLabel": "Oturum açan kullanıcı",

  "topbar.searchLabel": "Araç ara",
  "topbar.searchPlaceholder": "Filo no, model veya seri no ara…",
  "topbar.language": "Dil",
  "topbar.alarms": "Alarmlar",
  "topbar.alarmsCount": "{count} açık alarm",
  "topbar.noAlarms": "Açık alarm yok",
  "topbar.account": "Hesap: {name}",
  "topbar.breadcrumb": "Bulunduğunuz yer",

  "lang.tr": "TR",
  "lang.en": "EN",
  "lang.trName": "Türkçe",
  "lang.enName": "İngilizce",

  "login.eyebrow": "Operatör konsolu",
  "login.title": "Hoş geldiniz",
  "login.subtitle": "Filonuzu izlemek için hesabınızla giriş yapın.",
  "login.email": "E-posta",
  "login.password": "Şifre",
  "login.password.show": "Şifreyi göster",
  "login.password.hide": "Şifreyi gizle",
  "login.submit": "Giriş yap",
  "login.submitting": "Giriş yapılıyor…",
  "login.method.legend": "Giriş yöntemi",
  "login.method.password": "Şifre",
  "login.method.passwordDesc": "E-posta adresiniz ve şifrenizle",
  "login.method.code": "E-posta kodu",
  "login.method.codeDesc": "Şifresiz, tek kullanımlık kodla",
  "login.remember": "Beni hatırla",
  "login.forgot": "Şifremi unuttum?",
  "login.forgot.hint": "Kodla giriş yapın, sonra Profilim → Şifre bölümünden yeni şifre belirleyin.",
  "login.code.send": "Kod gönder",
  "login.code.sending": "Gönderiliyor…",
  "login.code.sent": "{email} adresine kayıtlı bir hesap varsa giriş kodunu gönderdik. E-postadaki bağlantıyla da giriş yapabilirsiniz.",
  "login.code.sentCodeOnly": "{email} adresine kayıtlı bir hesap varsa giriş kodunu gönderdik. Oturumunuzun bu tarayıcıyla sınırlı kalması için e-postadaki kodu buraya girin.",
  "login.code.changeEmail": "Farklı bir e-posta kullan",
  "login.code.label": "Giriş kodu",
  "login.code.help": "E-postadaki {n} haneli kodu girin.",
  "login.code.resend": "Kodu tekrar gönder",
  "login.code.resendIn": "Tekrar gönder ({s} sn)",
  "login.captcha.waiting": "Güvenlik doğrulaması tamamlanınca devam edebilirsiniz.",
  "login.captcha.loadFailed": "Güvenlik doğrulaması yüklenemedi. Sayfayı yenileyin; içerik engelleyici kullanıyorsanız bu siteye izin verin.",
  "login.help": "Hesabınızı firmanızın sistem yöneticisi oluşturur. Erişim için onunla iletişime geçin.",
  "login.footerCompany": "Expartise Makine",
  "login.hero.eyebrow": "Forklift Takip Sistemi",
  "login.hero.line1": "Tüm filonuz",
  "login.hero.line2": "tek ekranda.",
  "login.hero.caption": "Darbe, konum, kontrol listesi ve akü verisi tek konsolda.",
  "login.demo.summary": "Demo ve örnek hesaplar",
  "login.demo": "Demo ile devam et",
  "login.demoNote": "Demo modu yalnızca uydurma örnek verilerle çalışır; gerçek araç veya kişi verisi içermez.",
  "login.demoAccounts": "Rolleri denemek için örnek hesaplar (şifre: {password})",
  "login.demoCode": "Demo modunda e-posta gönderilmez. E-posta kodu yönteminde örnek hesaplar için kod: {code}",
  "login.error.required": "E-posta ve şifre girin.",
  "login.error.invalid": "E-posta veya şifre hatalı.",
  "login.error.emailRequired": "Geçerli bir e-posta adresi girin.",
  "login.error.codeRequired": "E-postadaki {n} haneli kodu girin.",
  "login.error.code": "Kod hatalı veya süresi dolmuş. Yeni kod isteyip tekrar deneyin.",
  "login.error.captcha": "Güvenlik doğrulaması başarısız oldu. Doğrulamayı yeniden tamamlayıp tekrar deneyin.",
  "login.error.rateLimited": "Çok fazla deneme yapıldı. Bir dakika bekleyip tekrar deneyin.",
  "login.error.notConfigured": "Sunucu bağlantısı henüz yapılandırılmadı.",
  "login.error.generic": "Giriş yapılamadı. Lütfen tekrar deneyin.",
  "login.footer": "Expartise Makine Ltd. Şti.",

  "dashboard.title": "Genel bakış",
  "dashboard.subtitle": "{tenant} filo özeti",
  "dashboard.sitesTitle": "Sahalar",
  "kpi.sites": "Saha ve birim",
  "kpi.sitesSub": "{count} ana saha",
  "kpi.vehicles": "Araç",
  "kpi.vehiclesSub": "{active} aktif · {inactive} pasif",
  "kpi.devices": "Cihaz bağlı araç",
  "kpi.devicesSub": "{count} araç cihaz bekliyor",
  "kpi.users": "Kullanıcı",
  "kpi.usersSub": "{count} yönetici",
  // Sprint 7b (ADR 0018): reports and the manager KPI panel.
  "dashboard.tabs": "Genel bakış görünümleri",
  "dashboard.summaryTab": "Filo özeti",
  "nav.reportChecklist": "Kontrol listesi uyumu",
  "nav.reportHeatmap": "Isı haritası",
  "nav.reportSpaghetti": "Spagetti diyagramı",
  "nav.reportDriving": "Sürüş karakteristiği",
  "error.report_too_large": "Rapor çok büyük: en fazla 18.400 araç-gün (ör. 92 gün × 200 araç). Tarih aralığını veya araç seçimini daraltın.",
  "error.export_too_large": "Dışa aktarım en fazla 50.000 satır içerebilir. Tarih aralığını veya filtreleri daraltın.",
  "error.invalid_report_range": "Tarih aralığı geçersiz. Geçerli tarihler seçin; en fazla 92 gün (rota raporunda en fazla 24 saat) seçilebilir.",
  "kpiPanel.title": "Yönetici paneli",
  "kpiPanel.period": "Dönem",
  "kpiPanel.period.today": "Bugün",
  "kpiPanel.period.7d": "7 gün",
  "kpiPanel.period.30d": "30 gün",
  "kpiPanel.noData": "Henüz veri yok",
  "kpiPanel.noCompare": "Karşılaştırma yok",
  "kpiPanel.vsPrevious": "önceki döneme göre",
  "kpiPanel.series": "Son {days} günün günlük değerleri",
  "kpiPanel.seriesSoc": "Son {days} günün ortalama şarj yüzdesi",
  "kpiPanel.utilisation": "Filo kullanım oranı",
  "kpiPanel.utilisationSub": "{active}/{total} cihazlı araç kullanıldı · esas: {basis}",
  "kpiPanel.basis.shifts": "vardiya saatleri",
  "kpiPanel.basis.24h": "günün 24 saati",
  "kpiPanel.basis.work": "mesai saatleri",
  "kpiPanel.basis.mixed": "vardiya ve mesai saatleri (karışık)",
  "kpiPanel.basisTip": "Kullanım oranı esası: {basis}. Vardiya tanımlı sahalarda vardiya saatleri, diğerlerinde sahanın mesai saatleri (varsayılan Pzt–Cum 08–18) kullanılır.",
  "kpiPanel.impacts": "Darbe",
  "kpiPanel.impactsPer100h": "100 çalışma saatinde {value} darbe",
  "kpiPanel.impactsNoHours": "Bu dönemde çalışma saati yok",
  "kpiPanel.checklist": "Kontrol listesi uyumu",
  "kpiPanel.checklistSub": "Kullanılan {used} vardiyanın {missed} tanesinde doldurulmadı",
  "kpiPanel.noShifts": "Vardiya tanımı yok",
  "kpiPanel.noShiftsSub": "Uyum, saha vardiyaları tanımlanınca hesaplanır.",
  "kpiPanel.faults": "Açık kritik arıza",
  "kpiPanel.faultsSub": "{count} araç \"Bakım gerekli\"",
  "kpiPanel.geofence": "Saha sınırı ihlalleri",
  "kpiPanel.geofenceSub": "Yasak bölgeye giriş {enter} · Alandan çıkış {exit} · Süre aşımı {dwell}",
  "kpiPanel.battery": "Akü",
  "kpiPanel.batterySub": "Derin deşarj {deep} · ortalama şarj %{avg}",
  "kpiPanel.lift": "Aşırı yük",
  "kpiPanel.liftSub": "Asansör modülünün bildirdiği aşırı yük olayları",
  "kpiPanel.documents": "Süresi yaklaşan operatör belgeleri",
  "kpiPanel.documentsSub": "30 gün içinde bitiyor · {expired} operatörün zorunlu belgesi bitmiş",
  "kpiPanel.footnote": "Saatler {tz} saat dilimine göre. Kullanım verisi dakikada bir güncellenir. Bir kutucuğa tıklayınca ilgili rapor aynı filtrelerle açılır.",
  "kpiPanel.withoutDevice": "{count} araçta henüz cihaz yok; kullanım oranına girmez.",
  "kpiPanel.batteryUnit": "araç düşük şarjda",
  "kpiPanel.deltaUp": "{value} arttı",
  "kpiPanel.deltaDown": "{value} azaldı",
  "kpiPanel.deltaFlat": "değişmedi",
  "overview.fleet.title": "Filo şu an",
  "overview.fleet.openMap": "Canlı haritada aç",
  "overview.fleet.tracked": "araç izleniyor",
  "overview.fleet.inAlarm": "{count} araçta alarm",
  "overview.fleet.untracked": "{count} araç izlenmiyor: cihazı yok veya pasif.",
  "overview.fleet.emptyTitle": "Henüz izlenen araç yok",
  "overview.fleet.emptyBody": "Araca telematik cihaz bağlandığında anlık durumu burada görünür.",
  "overview.fleet.emptyAction": "Cihazlara git",
  "overview.fleet.error": "Anlık durum güncellenemedi; son bilinen değerler gösteriliyor.",
  "overview.alarms.title": "Açık alarmlar",
  "overview.alarms.all": "Tüm alarmlar",
  "overview.alarms.emptyTitle": "Açık alarm yok",
  "overview.alarms.emptyBody": "Yeni bir darbe veya güvenlik olayı olduğunda burada görünür.",
  "overview.quick.title": "Hızlı erişim",
  "reports.sample": "Örnek veri",
  "reports.tz": "Günler ve saatler {tz} saat dilimine göre.",
  "reports.rows": "{count} satır",
  "reports.totals": "Toplamlar",
  "reports.noData": "Henüz veri yok. Bu filtrelere uyan kayıt bulunamadı.",
  "reports.truncated": "Liste ilk {max} satırla sınırlandı. Tarih aralığını veya filtreleri daraltın.",
  "reports.km": "{km} km",
  "reports.kg": "{kg} kg",
  "reports.hours": "{h} sa",
  // UI phase D (ADR 0031): report header, summary, charts, coverage, empty state, PDF.
  "reports.period": "Dönem",
  "reports.periodOne": "{from} (1 gün)",
  "reports.periodMany": "{from} – {to} ({days} gün)",
  "reports.context": "Rapor kapsamı",
  "reports.summary": "Özet",
  "reports.trend.up": "Önceki döneme göre {delta} artış",
  "reports.trend.down": "Önceki döneme göre {delta} azalış",
  "reports.trend.flat": "Önceki dönemle aynı",
  "reports.trend.new": "Önceki dönemde yoktu",
  "reports.trend.points": "{value} puan",
  "reports.trend.previous": "Önceki dönem {period}: {value}",
  "reports.coverage.title": "Bu dönemde eksik veri olabilir",
  "reports.coverage.future": "Dönem bugünü geçiyor; bugünden sonraki günler için henüz veri yok.",
  "reports.coverage.since": "Şu araçların cihazından gelen son veri (parantez içinde); sonrası için raporda veri yok. Araç kapalı ya da park hâlinde olabilir, cihaz çevrim dışı da olabilir:",
  "reports.coverage.all": "Dönem boyunca cihazından hiç veri gelmeyen araçlar: {vehicles}",
  "reports.coverage.limit": "Cihazın dönem içinde kısa süre bağlantısı kopup geri geldiyse bu aralıklar burada görünmez.",
  "reports.empty.title": "Bu dönemde veri yok",
  "reports.empty.body": "{period} · {site} için kayıt bulunamadı. Tarih aralığını genişletin ya da filtreleri değiştirin.",
  "reports.empty.last30": "Son 30 günü göster",
  "reports.chart.total": "Toplam",
  "reports.chart.view": "Grafik",
  "reports.unit.hours": "sa",
  "reports.usage.chart.byDay": "Günlere göre",
  "reports.usage.chart.byVehicle": "Araçlara göre",
  "reports.usage.chart.titleDay": "Günlük kullanım (saat)",
  "reports.usage.chart.titleVehicle": "Araç bazında kullanım (saat)",
  "reports.usage.series.moving": "Hareket",
  "reports.usage.series.idle": "Rölanti",
  "reports.usage.series.off": "Kontak açık değil / veri yok (esas süre içinde)",
  "reports.usage.chart.summary": "Toplam {moving} hareket, {idle} rölanti; esas süre içinde kontak açık değil ya da veri yok: {off}.",
  "reports.usage.chart.note": "Kontak açık değil / veri yok: seçilen kullanım esasının (vardiya, mesai ya da 24 saat) kontak açık geçmeyen kısmı. Cihaz bu sürede veri göndermediyse o süre de buraya girer; sistem ikisini ayıramaz. Hareket ve rölanti günün tamamını, bu kısım yalnızca esas süreyi kapsar; bu yüzden çubukların toplamı verilmez. Hiç kullanım kaydı olmayan araç-günler raporda yer almaz.",
  "reports.usage.vehiclesWithoutUse": "Bu dönemde kullanım kaydı olmayan araçlar: {vehicles}",
  "reports.events.total": "Toplam alarm",
  "reports.events.impacts": "Darbe",
  "reports.events.severe": "Seviye 3 darbe",
  "reports.events.open": "Onay bekleyen",
  "reports.events.offHours": "Mesai dışı",
  "reports.events.chart.title": "Günlük alarmlar",
  "reports.events.series.impact": "Darbe · seviye {level}",
  "reports.events.series.other": "Diğer alarmlar",
  "reports.events.chart.summary": "Dönemde {total} alarm; bunların {impacts} tanesi darbe, {severe} tanesi seviye 3 darbe.",
  "reports.events.chart.note": "Her alarm bir kez sayılır (tablodaki satırlar). Darbe dışındaki alarmların seviyesi sabittir; bu yüzden ayrı gösterilir.",
  "reports.checklist.chart.title": "Araç bazında kontrol listesi uyumu",
  "reports.checklist.chart.series": "Uyum",
  "reports.checklist.chart.summary": "{count} aracın uyumu, en düşükten en yükseğe: en düşük {min}, en yüksek {max}.",
  "reports.checklist.chart.note": "Vardiyası tanımlı olmayan araçlar grafikte yer almaz.",
  "reports.checklist.mttr": "Ort. giderme süresi",
  "reports.driving.chart.title": "Hareket süresinin hız aralıklarına dağılımı",
  "reports.driving.chart.all": "Tümü",
  "reports.driving.chart.summary": "Tümünde hareket süresinin {share} kadarı {band} aralığında geçti.",
  "reports.driving.chart.note": "Her çubuk bir satırın hareket süresinin %100'üdür. Tek kişiyi belli edecek gizli satırlar grafikte de yer almaz.",
  "reports.export.footer": "Expartise Makine · Forklift Takip Sistemi",
  "reports.export.chartCap": "Grafik ilk {shown} satırı gösterir (toplam {total}); tamamı aşağıdaki tablodadır.",
  "reports.export.summaryCapped": "Özet rakamlar ve grafik {total} satırın tamamından hesaplandı; tablo yalnızca ilk {shown} satırı gösterir.",
  "reports.export.sample": "Örnek veri: demo modunda uydurma kayıtlar",
  "charts.roleDescription": "grafik",
  "charts.showData": "Grafiğin verisini tablo olarak göster",
  "charts.category": "Grup",
  "reports.estimated": "(tahmini)",
  "reports.severity": "seviye {level}",
  "reports.operatorsHidden": "+{count} operatör (görme yetkiniz yok)",
  "reports.unknownCards": "Bilinmeyen kart: {count}",
  "reports.duration.hm": "{h} sa {m} dk",
  "reports.duration.m": "{m} dk",
  "reports.status.open": "Açık",
  "reports.status.acknowledged": "Onaylandı",
  "reports.basis.shifts": "Vardiya",
  "reports.basis.24h": "Günün 24 saati",
  "reports.basis.work": "Mesai saati",
  "reports.basis.shiftsShort": "vardiya",
  "reports.basis.24hShort": "24 sa",
  "reports.basis.workShort": "mesai",
  "reports.basis.shiftsHint": "Vardiya içindeki kontak süresi / vardiya süresi",
  "reports.basis.24hHint": "Kontak süresi / günün süresi",
  "reports.basis.workHint": "Mesai saatleri içindeki kontak süresi / mesai süresi",
  "reports.filter.basis": "Kullanım esası",
  "reports.basisOption.auto": "Varsayılan (vardiya varsa vardiya, yoksa mesai)",
  "reports.basisOption.shifts": "Vardiyaya göre",
  "reports.basisOption.work": "Mesai saatine göre",
  "reports.basisOption.workAt": "Mesai saatine göre ({hours})",
  "reports.basisOption.workVaries": "Mesai saatine göre (sahaya göre değişir)",
  "reports.filter.workHours": "Mesai saatleri",
  "reports.basisOption.24h": "Günün 24 saatine göre",
  "reports.range.tooLong": "En fazla 92 günlük aralık seçilebilir.",
  "reports.range.reversed": "Bitiş tarihi başlangıçtan önce olamaz.",
  "reports.range.invalid": "Geçerli bir tarih aralığı seçin.",
  "reports.range.routeTooLong": "Rota raporu en fazla 24 saatlik aralık gösterir.",
  "reports.filter.label": "Rapor filtreleri",
  "reports.filter.site": "Saha",
  "reports.filter.allSites": "Tüm sahalar",
  "reports.filter.vehicles": "Araçlar",
  "reports.filter.vehicle": "Araç",
  "reports.filter.allVehicles": "Tüm araçlar",
  "reports.filter.nVehicles": "{count} araç seçili",
  "reports.filter.clearVehicles": "Seçimi temizle",
  "reports.filter.chooseVehicle": "Araç seçin",
  "reports.filter.operator": "Operatör",
  "reports.filter.allOperators": "Tüm operatörler",
  "reports.filter.from": "Başlangıç tarihi",
  "reports.filter.to": "Bitiş tarihi",
  "reports.filter.dates": "Tarih aralığı",
  "reports.filter.types": "Olay türleri",
  "reports.filter.day": "Gün",
  "reports.filter.startTime": "Başlangıç saati",
  "reports.filter.endTime": "Bitiş saati",
  "reports.filter.window": "Zaman aralığı",
  "reports.group.impact": "Darbe",
  "reports.group.safety": "Güvenlik (koltuk, kemer, kartsız, müdahale)",
  "reports.group.geofence": "Saha sınırı",
  "reports.group.checklist": "Kontrol listesi",
  "reports.group.overload": "Aşırı yük",
  "reports.group.battery": "Akü",
  "reports.group.device_health": "Cihaz sağlığı",
  "reports.col.vehicle": "Araç",
  "reports.col.day": "Gün",
  "reports.col.ignition": "Kontak açık",
  "reports.col.moving": "Hareket",
  "reports.col.idle": "Rölanti",
  "reports.col.distanceKm": "Mesafe (km)",
  "reports.col.lifts": "Kaldırma",
  "reports.col.liftedKg": "Kaldırılan yük (kg)",
  "reports.col.utilisation": "Kullanım %",
  "reports.col.basis": "Kullanım esası",
  "reports.col.operators": "Operatörler",
  "reports.col.operator": "Operatör",
  "reports.col.time": "Zaman",
  "reports.col.type": "Tür",
  "reports.col.severity": "Önem",
  "reports.col.site": "Saha",
  "reports.col.status": "Durum",
  "reports.col.ackedAt": "Onay zamanı",
  "reports.col.ackNote": "Onay notu",
  "reports.col.zone": "Bölge",
  "reports.col.repeats": "Tekrar",
  "reports.col.lat": "Enlem",
  "reports.col.lon": "Boylam",
  "reports.col.speed": "Hız (km/sa)",
  "reports.col.ignitionOn": "Kontak",
  "reports.col.source": "Konum kaynağı",
  "reports.col.segment": "Bölüm",
  "reports.col.start": "Başlangıç",
  "reports.col.end": "Bitiş",
  "reports.col.duration": "Süre",
  "reports.col.maxSpeed": "En yüksek hız (km/sa)",
  "reports.col.shift": "Vardiya",
  "reports.col.shiftsUsed": "Kullanılan vardiya",
  "reports.col.shiftsChecked": "Doldurulan",
  "reports.col.missed": "Doldurulmayan",
  "reports.col.compliance": "Uyum %",
  "reports.col.submissions": "Gönderilen liste",
  "reports.col.faultsOpened": "Açılan arıza",
  "reports.col.faultsResolved": "Giderilen arıza",
  "reports.col.mttr": "Ort. giderme süresi (sa)",
  "reports.export.label": "Dışa aktar",
  "reports.export.csv": "CSV",
  "reports.export.csvSemicolon": "CSV (Türkçe Excel)",
  "reports.export.csvSemicolonHint": "Noktalı virgül ayraçlı ve ondalık virgüllü CSV; Türkçe Excel doğrudan açar.",
  "reports.export.xlsx": "Excel (XLSX)",
  "reports.export.pdf": "PDF",
  "reports.export.working": "Hazırlanıyor…",
  "reports.export.done": "Dosya hazırlandı ({rows} satır).",
  "reports.export.audit": "Her dışa aktarım kayıt altına alınır: kim, hangi rapor, hangi filtreler, kaç satır (1 yıl saklanır).",
  "reports.export.tooMany": "Dışa aktarım en fazla {max} satır içerebilir. Tarih aralığını veya filtreleri daraltın.",
  "reports.export.filters": "Filtreler",
  "reports.export.generatedAt": "Oluşturulma zamanı",
  "reports.export.generatedBy": "Oluşturan",
  "reports.export.timeZone": "Saat dilimi",
  "reports.export.page": "Sayfa {page} / {pages}",
  "reports.export.info": "Bilgi",
  "reports.export.pdfRowCap": "PDF ilk {shown} satırı gösterir (toplam {total}). Tamamı için Excel veya CSV indirin.",
  "reports.export.noRows": "Bu filtrelere uyan kayıt yok.",
  "reports.export.mapUnavailable": "Harita görüntüsü alınamadı; rota tablosu aşağıdadır.",
  "reports.usage.title": "Kullanım raporu",
  "reports.usage.slug": "kullanim",
  "reports.usage.subtitle": "Araç ve gün bazında kontak, hareket ve rölanti süreleri, mesafe, kaldırmalar, kullanım oranı ve operatörler.",
  "reports.usage.totalIgnition": "Toplam kontak açık",
  "reports.usage.totalMoving": "Toplam hareket",
  "reports.usage.totalDistance": "Toplam mesafe",
  "reports.usage.avgUtilisation": "Ortalama kullanım",
  "reports.usage.vehiclesUsed": "Kullanılan araç",
  "reports.usage.noLiftModule": "Bu araçta asansör ölçüm modülü yok",
  "reports.usage.rules": "Bir kaydın durumu bir sonraki kayda kadar, en fazla 2 dakika sürer; daha uzun boşluklar \"veri yok\" sayılır. Hareket: kontak açık ve hız en az 1 km/sa. Mesafe yalnızca doğru GNSS konumlarından hesaplanır; 40 km/sa'yi aşan sıçramalar ve durağan titreşim sayılmaz. Kullanım oranı, sahada vardiya varsa vardiya içindeki kontak süresinin vardiya süresine oranıdır, yoksa günün geçen süresine oranıdır. Kullanım, aracın bugünkü sahasına göre gösterilir.",
  "reports.events.title": "Olay raporu",
  "reports.events.slug": "olaylar",
  "reports.events.subtitle": "Alarm ve olaylar: tür, zaman, araç, operatör, saha, önem ve onay durumu.",
  "reports.events.rules": "Olaylar, olay anında aracın bulunduğu sahaya göre süzülür. Hız ihlali raporu Faz 2'de eklenecek.",
  "reports.route.title": "Rota raporu",
  "reports.route.slug": "rota",
  "reports.route.subtitle": "Tek araç, en fazla 24 saat: harita üzerinde rota, duraklar, saha sınırı olayları ve bölümler.",
  "reports.route.windowHint": "Saatler aracın sahasının saat dilimine göredir. Bitiş saati başlangıçtan önceyse aralık ertesi güne uzanır.",
  "reports.route.pickVehicle": "Rotasını görmek istediğiniz aracı seçin.",
  "reports.route.noPoints": "Bu aralıkta konum kaydı yok. Kapalı alanda GNSS konumu alınamayabilir.",
  "reports.route.map": "Harita",
  "reports.route.mapLabel": "{vehicle} rotası",
  "reports.route.mapError": "Harita yüklenemedi. Bölümler tablosu aşağıda.",
  "reports.route.legendTrack": "Rota",
  "reports.route.legendStop": "Durak (2 dakikadan uzun)",
  "reports.route.legendEvent": "Saha sınırı olayı",
  "reports.route.start": "Başlangıç",
  "reports.route.end": "Bitiş",
  "reports.route.drive": "Sürüş",
  "reports.route.stop": "Duruş",
  "reports.route.segments": "Bölümler",
  "reports.route.points": "Konum noktası",
  "reports.route.drivenDistance": "Sürüş mesafesi",
  "reports.route.drivingTime": "Sürüş süresi",
  "reports.route.stopsCount": "Durak sayısı",
  "reports.route.geofenceEvents": "Rotadaki saha sınırı olayları",
  "reports.route.dropped": "Gerçek dışı {count} konum sıçraması (40 km/sa üzeri) rotadan çıkarıldı.",
  "reports.route.droppedLabel": "Çıkarılan konum sıçraması",
  "reports.route.rules": "Durak: hızın 1 km/sa altında kaldığı veya kontağın kapalı olduğu, en az 2 dakika süren bölüm. Excel ve CSV tüm konum noktalarını, PDF harita görüntüsünü ve bölümleri içerir.",
  "reports.checklist.title": "Kontrol listesi uyum raporu",
  "reports.checklist.slug": "kontrol-listesi-uyum",
  "reports.checklist.subtitle": "Araç ve vardiya bazında kullanılan vardiyalar, doldurulan ve doldurulmayan kontrol listeleri, açılan ve giderilen arızalar.",
  "reports.checklist.noShifts": "Vardiya tanımı yok",
  "reports.checklist.totalCompliance": "Genel uyum",
  "reports.heatmap.title": "Isı haritası",
  "reports.heatmap.slug": "isi-haritasi",
  "reports.heatmap.subtitle": "Sahada olayların toplandığı ve araçların en çok hareket ettiği yerler.",
  "reports.heatmap.mode": "Gösterim",
  "reports.heatmap.mode.events": "Olaylar",
  "reports.heatmap.mode.usage": "Kullanım",
  "reports.heatmap.events": "Olay sayısı",
  "reports.heatmap.weight": "Ağırlıklı toplam",
  "reports.heatmap.points": "Hareketli konum noktası",
  "reports.heatmap.vehicles": "Araç sayısı",
  "reports.heatmap.cells": "Hücre (~{size} m)",
  "reports.heatmap.unlocated": "Konumu olmayan olay",
  "reports.heatmap.map": "Harita",
  "reports.heatmap.mapLabel": "Isı haritası: {mode}",
  "reports.heatmap.mapError": "Harita yüklenemedi. Özet bilgiler yukarıda; hücre listesini CSV veya Excel olarak indirebilirsiniz.",
  "reports.heatmap.mapUnavailable": "Harita görüntüsü alınamadı; özet ve en yoğun hücreler aşağıdadır.",
  "reports.heatmap.legend": "Yoğunluk",
  "reports.heatmap.legendLow": "Düşük",
  "reports.heatmap.legendHigh": "Yüksek",
  "reports.heatmap.legendAria": "Renk skalası: maviden kırmızıya, düşükten yükseğe yoğunluk",
  "reports.heatmap.zoomHint": "Yakınlaştırdıkça tek tek hücreler görünür.",
  "reports.heatmap.noEvents": "Bu dönemde konumu bilinen olay yok.",
  "reports.heatmap.noUsage": "Bu dönemde hareket kaydı yok. Harita için araçlardan GNSS konumu gelmiş olmalıdır.",
  "reports.heatmap.truncated": "En yoğun {max} hücre gösteriliyor (toplam {total}). Ayrıntı için tarih aralığını veya araç seçimini daraltın.",
  "reports.heatmap.rangeTooLong": "Isı haritası en fazla 31 günlük aralık gösterir.",
  "reports.heatmap.tooLarge": "Kullanım ısı haritası en fazla {max} araç-gün işler (ör. 31 gün × 12 araç veya 7 gün × 57 araç). Tarih aralığını veya araç seçimini daraltın.",
  "reports.heatmap.rules.events": "Olaylar, olay anında aracın bulunduğu sahaya göre süzülür. Darbeler seviyesine göre (1–3) ağırlık alır, diğer olaylar 1 sayılır. Hücreler yaklaşık {size} m boyundadır. Kontrol listesi alarmlarının konumu yoktur, haritaya alınmaz. Konumu olmayan diğer olaylar (ör. kartsız çalıştırma) haritaya girmez, ayrıca sayılır.",
  "reports.heatmap.rules.usage": "Kontak açık ve hızı en az 1 km/sa olan, cihaz saati doğrulanmış GNSS konumları sayılır (doğruluk bilgisi varsa en fazla 15 m); saniyelik iz noktaları dahildir. Araçlar bugünkü sahalarına göre süzülür. Hücreler yaklaşık {size} m boyundadır.",
  "reports.heatmap.kvkk": "Haritada operatör veya kart bilgisi yoktur; yalnızca toplu konum yoğunluğu gösterilir.",
  "reports.heatmap.sheetCells": "Hücreler",
  "reports.heatmap.sheetTop": "En yoğun {count} hücre",
  "reports.heatmap.col.rank": "Sıra",
  "reports.heatmap.col.weight": "Ağırlık",
  "reports.heatmap.col.events": "Olay",
  "reports.heatmap.col.points": "Nokta",
  "reports.hover.speed": "{v} km/sa",
  "reports.spaghetti.title": "Spagetti diyagramı",
  "reports.spaghetti.slug": "spagetti-diyagrami",
  "reports.spaghetti.subtitle": "Seçilen araçların rotaları tek haritada: akış, kesişme noktaları ve yoğun koridorlar.",
  "reports.spaghetti.color": "Renk",
  "reports.spaghetti.color.vehicles": "Araç renkleri",
  "reports.spaghetti.color.density": "Tek renk (yoğunluk)",
  "reports.spaghetti.vehicles": "Araç sayısı",
  "reports.spaghetti.distance": "Hareketli mesafe",
  "reports.spaghetti.moving": "Hareket süresi",
  "reports.spaghetti.points": "Çizilen nokta",
  "reports.spaghetti.map": "Harita",
  "reports.spaghetti.mapLabel": "Spagetti diyagramı",
  "reports.spaghetti.mapError": "Harita yüklenemedi. Özet bilgiler yukarıda; araç özetini CSV veya Excel olarak indirebilirsiniz.",
  "reports.spaghetti.mapUnavailable": "Harita görüntüsü alınamadı; araç özeti aşağıdadır.",
  "reports.spaghetti.legend": "Araçlar (göster / gizle)",
  "reports.spaghetti.overlapHint": "Çizgiler yarı saydamdır: üst üste binen geçişler koyu görünür.",
  "reports.spaghetti.densityHint": "Tek renkte koyulaşan yerler, en çok kullanılan koridorlardır.",
  "reports.spaghetti.empty": "Bu dönemde hareket kaydı yok. Diyagram için araçlardan GNSS konumu gelmiş olmalıdır.",
  "reports.spaghetti.truncated": "Nokta sayısı çok fazla olduğu için rotalar yaklaşık {spacing} saniyede bir noktayla çiziliyor (en fazla {max} nokta). Hareketli mesafe ve süre, seyreltmeden önceki bütün hareketli noktalardan hesaplanır. Daha ayrıntılı çizim için tarih aralığını veya araç seçimini daraltın.",
  "reports.spaghetti.rangeTooLong": "Spagetti diyagramı en fazla 31 günlük aralık gösterir.",
  "reports.spaghetti.tooLarge": "Spagetti diyagramı en fazla {max} araç-gün işler (ör. 7 gün × 28 araç veya 31 gün × 6 araç). Tarih aralığını veya araç seçimini daraltın.",
  "reports.spaghetti.rules": "Kontak açık ve hızı en az 1 km/sa olan, cihaz saati doğrulanmış GNSS konumları çizilir (doğruluk bilgisi varsa en fazla 15 m); saniyelik iz noktaları dahildir. Sunucu her aracın her {bucket} saniyesinden bir nokta alır. {gap} saniyeden uzun aralar ve {jump} km/sa üstü sıçramalar çizgiyi böler; tek kalan sıçrama noktası çizilmez. Hareketli mesafe yalnızca hareketli noktalar üzerinden hesaplanır (kullanım raporunun mesafesi bütün GNSS noktalarını kullanır, küçük farklar olabilir); hareket süresi kullanım raporuyla aynıdır. Araçlar bugünkü sahalarına göre süzülür.",
  "reports.spaghetti.kvkk": "Diyagramda operatör veya kart bilgisi yoktur; yalnızca araç başına konum gösterilir.",
  "reports.spaghetti.sheetVehicles": "Araçlar",
  "reports.spaghetti.sheetPoints": "Noktalar",
  "reports.spaghetti.col.movingDistanceKm": "Hareketli mesafe (km)",
  "reports.spaghetti.col.lines": "Çizgi",
  "reports.spaghetti.col.points": "Çizilen nokta",
  "reports.spaghetti.col.movingPoints": "Hareketli konum noktası",
  "reports.spaghetti.col.line": "Çizgi no",
  "reports.spaghetti.col.order": "Sıra",
  "reports.driving.title": "Sürüş karakteristiği",
  "reports.driving.slug": "surus-karakteristigi",
  "reports.driving.subtitle": "Operatör veya araç başına: hareket süresi, mesafe, hızlar, hız bantları ve güvenlik olayları.",
  "reports.driving.kvkkNote": "Bu rapor çalışanların araç kullanımına ilişkin kişisel veri içerir ve yalnızca İSG eğitimi ve koçluk amacıyla kullanılmalıdır; her dışa aktarım kayıt altına alınır. Sonuçlar operatörlerle paylaşılır; paylaşım öncesi çalışanlara KVKK aydınlatma metni verilmiş olmalıdır.",
  "reports.driving.purposeLabel": "Amaç",
  "reports.driving.purpose": "İSG eğitimi ve koçluk (kişisel veri)",
  "reports.driving.group": "Gruplama",
  "reports.driving.group.operator": "Operatöre göre",
  "reports.driving.group.vehicle": "Araca göre",
  "reports.driving.noCard": "Kartsız / operatör bilinmiyor",
  "reports.driving.suppressed": "Tek bir operatör olduğu için değerler gösterilmez (kişi tek başına ayırt edilmesin diye); toplamlara da katılmaz.",
  "reports.driving.impacts": "Darbe",
  "reports.driving.col.vehicles": "Araç sayısı",
  "reports.driving.col.avgKmh": "Ort. hareket hızı (km/sa)",
  "reports.driving.col.maxKmh": "En yüksek hız (km/sa)",
  "reports.driving.col.band": "Hız bandı {band} km/sa (%)",
  "reports.driving.col.bandShort": "{band} km/sa",
  "reports.driving.col.impact": "Darbe · Seviye {level}",
  "reports.driving.col.events": "Olay toplamı",
  "reports.driving.col.eventsRate": "Olay / {h} hareket saati",
  "reports.driving.col.impactsRate": "Darbe / {h} hareket saati",
  "reports.driving.outliers": "{count} hız değeri {max} km/sa üstünde olduğu için sensör/GNSS sıçraması sayıldı ve en yüksek hıza alınmadı.",
  "reports.driving.rangeTooLong": "Sürüş karakteristiği en fazla 31 günlük aralık gösterir.",
  "reports.driving.tooLarge": "Sürüş karakteristiği en fazla {max} araç-gün işler (ör. 31 gün × 12 araç veya 7 gün × 57 araç). Tarih aralığını veya araç seçimini daraltın.",
  "reports.driving.narrow": "Saha, araç veya tarih aralığını daraltın.",
  "reports.driving.rules": "Hareket: kontak açık ve hız en az 1 km/sa; her kayıt bir sonrakine kadar, en fazla 120 sn sürer (kullanım raporuyla aynı). Hız bantları ({bands} km/sa) hareket süresinin payıdır. En yüksek hız, cihaz saati doğrulanmış kayıtlardaki bildirilen hızdır; {max} km/sa üstü değerler sıçrama sayılır. Mesafe GNSS konumlarından hesaplanır. Olaylar alarmlardan gelir (darbe seviyeye göre, koltuk ve kemer ihlali, yasak bölgeye giriş, çalışma alanından çıkış, aşırı yük); oranlar {h} hareket saati başınadır ve en az 1 saatlik harekette verilir. Süre kartın oturumuna, olay olay anındaki karta yazılır. Araçlar bugünkü sahalarına göre süzülür.",
  "reports.driving.notMeasured": "Sert hızlanma, sert fren ve keskin dönüş bugün ölçülmüyor (cihazlardan bu olaylar gelmiyor; GNSS’ten tahmin edilmez). Hız sınırı tanımlı olmadığı için hız ihlali de gösterilmez. Bu rapor bir puan vermez; yalnızca ölçülen değerleri gösterir.",
  "reports.checklist.rules": "Uyum: aracın kullanıldığı vardiyalardan kontrol listesi doldurulanların oranı (vardiya başlangıcından 30 dakika önce dahil). Gönderim ve arızalar, gönderim anındaki sahaya göre süzülür; vardiya kullanımı aracın bugünkü sahasına göre hesaplanır.",

  "sites.title": "Sahalar",
  "sites.subtitle": "{count} saha ve alt birim",
  "sites.empty": "Bu kiracıda henüz saha tanımlı değil.",

  "site.name": "Ad",
  "site.kind": "Tür",
  "site.address": "Adres",
  "site.vehicles": "Araç",
  "site.childCount": "Alt birim",
  "site.noAddress": "Adres girilmemiş",
  "site.childSites": "Alt birimler",
  "site.noChildren": "Bu sahanın alt birimi yok.",
  "site.vehiclesTitle": "Araçlar",
  "site.vehiclesSummary": "{direct} bu birimde · {total} alt birimlerle birlikte",
  "site.noVehicles": "Bu birimde ve alt birimlerinde kayıtlı araç yok.",
  "site.notFound": "Saha bulunamadı veya erişim yetkiniz yok.",

  "siteKind.site": "Saha",
  "siteKind.warehouse": "Depo",
  "siteKind.department": "Bölüm",
  "siteKind.zone": "Bölge",

  "vehicle.fleetNo": "Filo no",
  "vehicle.type": "Tür",
  "vehicle.power": "Enerji",
  "vehicle.makeModel": "Marka / model",
  "vehicle.make": "Marka",
  "vehicle.model": "Model",
  "vehicle.serialNo": "Seri no",
  "vehicle.battery": "Akü (V)",
  "vehicle.batteryValue": "{value} V",
  "vehicle.device": "Cihaz",
  "vehicle.noDevice": "Bağlı değil",
  "vehicle.status": "Durum",
  "vehicle.site": "Saha",
  "vehicle.active": "Aktif",
  "vehicle.notFound": "Araç bulunamadı veya erişim yetkiniz yok.",

  "vehicleType.forklift": "Forklift",
  "vehicleType.reach_truck": "Reach truck",
  "vehicleType.order_picker": "Sipariş toplayıcı",
  "vehicleType.pallet_truck": "Akülü transpalet",
  "vehicleType.other": "Diğer",

  "power.electric": "Elektrikli",
  "power.diesel": "Dizel",
  "power.lpg": "LPG",

  "status.ready": "Cihaz bağlı",
  "status.no_device": "Cihaz bekliyor",
  "status.inactive": "Pasif",

  "vehicles.title": "Araçlar",
  "vehicles.count": "{shown} / {total} araç",
  "vehicles.filterSite": "Saha",
  "vehicles.filterType": "Tür",
  "vehicles.filterSearch": "Ara",
  "vehicles.all": "Tümü",
  "vehicles.clear": "Filtreleri temizle",
  "vehicles.empty": "Filtrelere uyan araç yok.",
  "vehicles.filtersLabel": "Araç filtreleri",

  "vehicleDetail.tabsLabel": "Araç bölümleri",
  "vehicleDetail.tab.general": "Genel",
  "vehicleDetail.tab.live": "Canlı durum",
  "vehicleDetail.tab.events": "Olaylar",
  "vehicleDetail.tab.operators": "Yetkili operatörler",
  "vehicleDetail.tab.device": "Cihaz",
  "vehicleDetail.tab.audit": "Denetim",
  "vehicleDetail.identity": "Araç kimliği",
  "vehicleDetail.assignment": "Konum ve cihaz",
  "vehicleDetail.tabSoon": "“{tab}” bölümü sonraki sprintlerde eklenecek. Şimdilik gösterilecek veri yok.",
  // Sprint 7a: battery and lift modules (ICD v0.2 section 9, ADR 0017)
  "modules.alarmNoBlock": "Araç, sürüş veya kaldırma engellenmez; akü ve asansör alarmları yalnızca bildirimdir.",
  "modules.battery.chargedKwh": "{value} kWh",
  "modules.value.kgPerBar": "{value} kg/bar",
  "modules.lift.noLoad": "yük bilgisi yok",
  "modules.lift.estimated": "tahmini",
  "modules.lift.estimatedHint": "Cihaz yük göndermedi; bulut, araç ayarlarıyla tahmin etti.",
  "modules.batType.lead_acid": "Kurşun asit",
  "modules.batType.lithium": "Lityum",
  "modules.settings.title": "Modül ayarları",
  "modules.settings.description": "Akü türü, kapasite, kalibrasyon katsayısı ve kaldırma eşiği cihaza gönderilir; cihaz şarj yüzdesini ve yükü bunlarla hesaplar. Değişiklikler bir dakika içinde gönderilir.",
  "modules.settings.batType": "Akü türü",
  "modules.settings.batAh": "Akü kapasitesi",
  "modules.settings.batAhLabel": "Akü kapasitesi (Ah)",
  "modules.settings.kgPerBar": "Kalibrasyon katsayısı",
  "modules.settings.kgPerBarLabel": "Kalibrasyon katsayısı (kg/bar)",
  "modules.settings.kgPerBarHint": "Bilinen yükle yapılan kalibrasyondan; cihaz yükü bununla tahmin eder.",
  "modules.settings.threshold": "Kaldırma eşiği",
  "modules.settings.thresholdLabel": "Kaldırma eşiği (bar)",
  "modules.settings.thresholdHint": "Basınç bunu aşınca kaldırma döngüsü başlar.",
  "modules.settings.emptyBarLabel": "Boş çatal basıncı (bar)",
  "modules.settings.emptyBarHint": "Cihaza gönderilmez; yalnızca cihaz yük göndermediğinde bulutun tahmininde kullanılır.",
  "modules.settings.ratedLabel": "Nominal kapasite (kg)",
  "modules.settings.range": "{min} ile {max} arasında bir sayı girin.",
  "modules.settings.delivery": "Cihaza iletim",
  "modules.settings.note": "Ayarlar yalnızca ölçümü etkiler; araç, sürüş veya kaldırma hiçbir koşulda engellenmez.",
  "modules.delivery.none": "Ayar yok",
  "modules.delivery.pending": "Cihaz onayı bekleniyor",
  "modules.delivery.acked": "Cihaz onayladı",
  "modules.delivery.failed": "Gönderilemedi",
  "modules.delivery.kept": "Cihaz son değerleri saklıyor",
  "modules.settings.locked": "Cihaz son değeri saklar; alan boşaltılamaz, yeni değer girin.",
  "error.module_setting_locked": "Cihaza gönderilmiş bir ayar boşaltılamaz; cihaz son değeri saklar. Yeni bir değer girin.",
  "modules.loadError": "Akü ve asansör verisi yüklenemedi.",
  "modules.value.percent": "%{value}",
  "modules.value.volts": "{value} V",
  "modules.value.amps": "{value} A",
  "modules.value.celsius": "{value} °C",
  "modules.value.kg": "{value} kg",
  "modules.value.bar": "{value} bar",
  "modules.value.meters": "{value} m",
  "modules.battery.title": "Akü",
  "modules.battery.soc": "Şarj durumu",
  "modules.battery.voltage": "Gerilim",
  "modules.battery.current": "Akım",
  "modules.battery.currentHint": "+ şarj, − deşarj",
  "modules.battery.temperature": "Sıcaklık",
  "modules.battery.state": "Durum",
  "modules.battery.lastCharge": "Son şarj",
  "modules.battery.socRange": "%{from} → %{to}",
  "modules.battery.chargedAh": "{value} Ah",
  "modules.battery.noCharge": "Son 7 günde şarj kaydı yok",
  "modules.battery.chargingSince": "Şarj başladı: {when}",
  "modules.battery.incomplete": "eksik kayıt",
  "modules.battery.readingAt": "Son ölçüm: {when}",
  "modules.battery.noReading": "Henüz akü ölçümü gelmedi.",
  "modules.battery.low": "Şarj düşük: aracı şarja alın.",
  "modules.battery.sparkline": "Son 24 saatte şarj durumu",
  "modules.battery.sparklineRange": "En düşük %{min} · en yüksek %{max}",
  "modules.battery.sparklineEmpty": "Son 24 saatte akü verisi yok.",
  "modules.battery.nominal": "{value} V akü",
  "modules.state.charging": "Şarj oluyor",
  "modules.state.discharging": "Kullanımda",
  "modules.state.resting": "Beklemede",
  "modules.state.unknown": "Bilinmiyor",
  "modules.lift.title": "Asansör (kaldırma)",
  "modules.lift.today": "Bugün",
  "modules.lift.todayValue": "{lifts} kaldırma · {overloads} aşırı yük",
  "modules.lift.last": "Son kaldırmalar",
  "modules.lift.colTime": "Zaman",
  "modules.lift.colLoad": "Yük",
  "modules.lift.colHeight": "Yükseklik",
  "modules.lift.colPressure": "Basınç",
  "modules.lift.overloadBadge": "Aşırı yük",
  "modules.lift.none": "Henüz kaldırma kaydı yok.",
  "modules.lift.capacity": "Nominal kapasite",
  "modules.lift.estimateNote": "Yük, cihazın kalibrasyon katsayısıyla hesapladığı tahmindir (yaklaşık ±%5). Aşırı yük yalnızca bildirilir; araç veya kaldırma engellenmez.",
  "map.detail.soc": "Akü şarjı",
  "map.socBadge": "Akü %{value}",

  "users.title": "Kullanıcılar ve roller",
  "users.subtitle": "{count} kullanıcı bu kiracıya erişebiliyor",
  "users.name": "Ad",
  "users.email": "E-posta",
  "users.role": "Rol",
  "users.scope": "Erişim kapsamı",
  "users.allSites": "Tüm sahalar",
  "users.siteCount": "{count} saha",
  "users.empty": "Bu kiracıda kullanıcı yok.",
  "users.rolesTitle": "Roller",
  "users.roleHelp.viewer": "Ekranları görüntüler, değişiklik yapamaz.",
  "users.roleHelp.safety": "Darbe ve olayları izler, İSG raporlarına erişir.",
  "users.roleHelp.fleet_manager": "Araç, cihaz, operatör ve yetkileri yönetir.",
  "users.roleHelp.admin": "Kullanıcıları, rolleri ve kiracı ayarlarını yönetir.",
  "users.alarmMail.title": "Alarm e-postaları",
  "users.alarmMail.copyAdmins": "Yöneticiler her alarmın kopyasını alsın",
  "users.alarmMail.hint": "Alarm e-postaları normalde İSG sorumlusuna ve filo yöneticisine gider; yöneticiler yalnızca bu rollerde e-posta alabilecek kimse yoksa alır. Açıkken yöneticiler de her alarmın kopyasını alır.",
  "users.alarmMail.readOnly": "Bu ayarı yalnızca yöneticiler değiştirebilir.",

  "access.title": "Erişim yok",
  "access.body": "Bu ekranı görüntülemek için yetkiniz bulunmuyor. Gerekirse kiracı yöneticinizle görüşün.",

  "soon.title": "Bu ekran yakında",
  "soon.body": "{feature} ekranı sonraki sprintlerde eklenecek. Şu an gösterilecek veri yok.",
  "soon.unknownTitle": "Sayfa bulunamadı",
  "soon.unknownBody": "Bu adreste bir ekran yok. Menüden devam edebilirsiniz.",

  "common.cancel": "Vazgeç",
  "common.close": "Kapat",
  "common.save": "Kaydet",
  "dvr.title": "Kayıt cihazı sağlığı",
  "dvr.ok": "Sorun yok",
  "dvr.problems": "{count} sorun",
  "dvr.problemOne": "1 sorun",
  "dvr.stale": "veri yok / güncel değil (son bildirim {at})",
  "dvr.noReport": "Kayıt cihazı henüz kamera ve kayıt ortamı durumu bildirmedi.",
  "dvr.notRecorder": "Bu cihaz kayıt cihazı durumu bildirmiyor. Gerekirse beklenen kayıt ortamını ve takılı kameraları ayarlayın.",
  "dvr.reportedAt": "Son bildirim: {at}",
  "dvr.openProblems": "Açık sorunlar",
  "dvr.since": "{at} itibarıyla",
  "dvr.alarmed": "alarm oluşturuldu",
  "dvr.issue.storage": "{medium}: {state}",
  "dvr.issue.camera": "Kanal {ch}: {state}",
  "dvr.storageTitle": "Kayıt ortamı",
  "dvr.camerasTitle": "Takılı kameralar",
  "dvr.channel": "Kanal {ch}",
  "dvr.expected": "beklenen",
  "dvr.videoLoss": "görüntü yok",
  "dvr.none": "yok",
  "dvr.default": "Varsayılan",
  "dvr.settingsSummary": "Beklenen kayıt ortamı: {medium}. Takılı kameralar: {cameras}.",
  "dvr.fieldCaveat": "Bir sorun 10 dakika sürerse alarm oluşur, 2 dakika düzgün bildirilince kapanır. Kamera durumlarının anlamı sahada doğrulanmayı bekliyor.",
  "dvr.editSettings": "Ayarları değiştir",
  "dvr.mediumLabel": "Beklenen kayıt ortamı",
  "dvr.camerasLabel": "Takılı kamera kanalları",
  "dvr.medium.ssd": "SSD",
  "dvr.medium.sd": "SD kart",
  "dvr.medium.usb": "USB",
  "dvr.medium.usb2": "USB 2",
  "dvr.camera.recording": "kayıt yapıyor",
  "dvr.camera.not_recording": "kayıt yapmıyor",
  "dvr.camera.disabled": "kapalı",
  "dvr.camera.abnormal": "sorunlu",
  "dvr.camera.unknown": "bilinmiyor",
  "dvr.storage.normal": "normal",
  "dvr.storage.disabled": "kapalı",
  "dvr.storage.absent": "takılı değil",
  "dvr.storage.full": "dolu (üzerine yazma kapalı)",
  "dvr.storage.unformatted": "biçimlendirilmemiş",
  "dvr.storage.write_error": "yazma hatası",
  "dvr.storage.unknown": "bilinmiyor",
  "devices.health": "Kayıt cihazı",
  "devices.healthCardHelp": "Kayıt cihazı alanı neyi gösterir?",
  "common.edit": "Düzenle",
  "common.delete": "Sil",
  "common.ok": "Tamam",
  "common.working": "İşleniyor…",
  "common.actions": "İşlemler",
  "common.copy": "Kopyala",
  "common.copied": "Kopyalandı",
  "common.copyFailed": "Kopyalanamadı",

  "form.optional": "isteğe bağlı",
  "form.required": "Bu alan zorunlu.",
  "form.tooLong": "En fazla {max} karakter olabilir.",
  "form.select": "Seçin…",
  "form.chooseOne": "Bir seçim yapın.",

  "nav.inventory": "Cihaz envanteri",

  "error.invalid_credentials": "E-posta veya şifre hatalı.",
  "error.captcha_failed": "Güvenlik doğrulaması başarısız oldu. Tekrar deneyin.",
  "error.invalid_code": "Kod hatalı veya süresi dolmuş.",
  "error.not_configured": "Sunucu bağlantısı henüz yapılandırılmadı.",
  "error.unknown": "İşlem tamamlanamadı. Bilgileri kontrol edip tekrar deneyin.",
  "error.forbidden": "Bu işlem için yetkiniz yok.",
  "error.invalid_device_id": "Cihaz numarası geçersiz. Büyük harf, rakam ve tire kullanın (ör. FTS-000123).",
  "error.device_exists": "Bu cihaz numarası zaten kayıtlı.",
  "error.device_not_found": "Cihaz bulunamadı.",
  "error.device_revoked": "Bu cihaz engellenmiş, araca bağlanamaz.",
  "error.device_busy": "Bu cihaz zaten başka bir araca bağlı. Önce o araçtan ayırın.",
  "error.vehicle_busy": "Bu araçta zaten bir cihaz var. Önce mevcut cihazı ayırın.",
  "error.vehicle_inactive": "Pasif araçlara cihaz bağlanamaz. Önce aracı aktif yapın.",
  "error.tenant_mismatch": "Bu cihaz firmanıza ait değil.",
  "error.claim_invalid": "Cihaz numarası ya da etiket kodu hatalı veya cihaz daha önce eklenmiş.",
  "error.invalid_email": "Geçerli bir e-posta adresi girin.",
  "error.invalid_scope": "Erişim kapsamı geçersiz. Yöneticiler tüm sahalara erişir; saha seçimi yalnızca diğer roller için yapılabilir.",
  "error.already_member": "Bu kişi zaten bu firmanın kullanıcısı.",
  "error.invitation_invalid": "Bu davet artık geçerli değil.",
  "error.wrong_email": "Bu davet başka bir e-posta adresine gönderilmiş. Davetin gönderildiği adresle giriş yapın.",
  "error.scope_changed": "Davetteki sahalardan biri silinmiş. Yöneticinizden yeni bir davet isteyin.",
  "error.site_is_last_scope": "Bu saha, bir kullanıcının erişebildiği tek saha. Silmeden önce o kullanıcının erişim kapsamını değiştirin.",
  "error.vehicle_has_history": "Bu aracın kayıtlı verisi var, silinemez. Kullanımdan kaldırmak için aracı pasif yapın.",
  "error.rate_limited": "Bu işlem çok sık yapıldı. Bir dakika bekleyip tekrar deneyin. Aynı davet en fazla 5 kez e-postayla gönderilebilir; sınıra ulaştıysanız yeni bir davet oluşturun.",
  "error.unauthorized": "Oturumunuzun süresi dolmuş. Lütfen yeniden giriş yapın.",
  "error.bad_request": "Sunucu isteği kabul etmedi. Sayfayı yenileyip tekrar deneyin.",
  "error.not_found": "İstenen kayıt sunucuda bulunamadı.",
  "error.broker_error": "MQTT sunucusuna ulaşılamadı. Biraz sonra tekrar deneyin.",
  "error.mail_error": "E-posta gönderilemedi. Biraz sonra tekrar deneyin ya da bağlantıyı kopyalayıp kendiniz iletin.",

  "login.sendLink": "Giriş bağlantısı gönder",

  "deviceState.online": "Çevrim içi",
  "deviceState.offline": "Çevrim dışı",
  "deviceState.revoked": "Engellendi",

  "device.id": "Cihaz no",
  "device.vehicle": "Araç",
  "device.status": "Durum",
  "device.lastSeen": "Son bağlantı",
  "device.neverSeen": "Henüz bağlanmadı",
  "device.firmware": "Yazılım",
  "device.claimedAt": "Eklenme",
  "device.imei": "IMEI",
  "device.iccid": "ICCID",
  "device.unpaired": "Araca bağlı değil",

  "devices.title": "Cihazlar",
  "devices.subtitle": "{count} cihaz · {paired} tanesi araca bağlı",
  "devices.add": "Cihaz ekle",
  "devices.pair": "Araca bağla",
  "devices.unpair": "Araçtan ayır",
  "devices.claimed": "{device} firmanıza eklendi.",
  "devices.empty": "Henüz cihaz yok.",
  "devices.emptyManager": "Telematik üniteyi etiketindeki kodla “Cihaz ekle” üzerinden ekleyin, sonra bir araca bağlayın.",
  "devices.emptyViewer": "Görebildiğiniz araçlara bağlı cihaz bulunmuyor.",
  "devices.readOnly": "Cihaz eklemek ve araçlara bağlamak filo yöneticisi yetkisi gerektirir.",

  "claim.title": "Cihaz ekle",
  "claim.description": "Size gönderilen telematik üniteyi firmanıza ekleyin. Cihaz numarası ve etiket kodu, cihazın üzerindeki etikette yazar.",
  "claim.code": "Etiket kodu",
  "claim.codeHint": "12 karakterlik kod (ör. 0A1B-2C3D-4E5F). Tire ve boşluklar önemli değil. Her kod yalnızca bir kez kullanılabilir.",
  "claim.codeFormat": "Kod 12 karakter olmalı (0–9, A–F).",
  "claim.submit": "Cihazı ekle",
  "claim.demoHint": "Demo için örnek etiket kodları: {codes}",

  "pair.titleDevice": "{device} cihazını araca bağla",
  "pair.titleVehicle": "{vehicle} aracına cihaz bağla",
  "pair.description": "Bir araçta aynı anda yalnızca bir cihaz olabilir. Hangi cihazın hangi araçta olduğu geçmişiyle saklanır.",
  "pair.vehicle": "Araç",
  "pair.vehicleHint": "Yalnızca aktif ve cihazı olmayan araçlar listelenir.",
  "pair.device": "Cihaz",
  "pair.noVehicles": "Bağlanabilecek araç yok: tüm aktif araçlarda zaten bir cihaz var.",
  "pair.noDevices": "Bağlanabilecek cihaz yok. Önce “Cihazlar” ekranından bir cihaz ekleyin.",
  "pair.submit": "Bağla",

  "unpair.title": "Cihazı araçtan ayır",
  "unpair.body": "{device} cihazı {vehicle} aracından ayrılacak. Cihaz firmanızda kalır ve başka bir araca bağlanabilir.",
  "unpair.submit": "Ayır",

  "vehicleDevice.title": "Telematik cihaz",
  "vehicleDevice.none": "Bu araca bağlı cihaz yok.",
  "vehicleDevice.inactive": "Araç pasif olduğu için cihaz bağlanamaz.",
  "vehicleDevice.pair": "Cihaz bağla",

  "inventory.title": "Cihaz envanteri",
  "inventory.subtitle": "{total} kayıtlı cihaz · {inventory} tanesi envanterde",
  "inventory.register": "Cihaz kaydet",
  "inventory.tenant": "Firma",
  "inventory.inStock": "Envanterde",
  "inventory.onVehicle": "araca bağlı",
  "inventory.rotate": "Gizli anahtarı yenile",
  "inventory.revoke": "Engelle",
  "inventory.unrevoke": "Engeli kaldır",
  "inventory.release": "Envantere geri al",
  "inventory.filter": "Durum",
  "inventory.filterInventory": "Envanterde",
  "inventory.filterClaimed": "Firmaya eklenmiş",
  "inventory.filterRevoked": "Engellenmiş",
  "inventory.filtersLabel": "Envanter filtreleri",
  "inventory.searchPlaceholder": "Cihaz no, IMEI, ICCID",
  "inventory.empty": "Henüz kayıtlı cihaz yok.",
  "inventory.noMatch": "Filtrelere uyan cihaz yok.",
  "inventory.note": "Bu ekranı yalnızca Expartise platform yöneticileri görür. Gizli anahtarlar ve etiket kodları veritabanında yalnızca özet (hash) olarak tutulur, sonradan görüntülenemez.",

  "register.title": "Cihaz kaydet",
  "register.description": "Her satıra bir cihaz yazın. Kayıt sırasında her cihaz için bir gizli anahtar ve bir etiket kodu üretilir.",
  "register.lines": "Cihazlar",
  "register.linesHint": "Biçim: CİHAZ_NO[,IMEI[,ICCID]], ör. FTS-000123,350000000000123",
  "register.lineErrors": "Hatalı satırlar",
  "register.lineNo": "Satır {line}:",
  "register.lineInvalid": "cihaz numarası geçersiz (büyük harf, rakam ve tire; 3–32 karakter)",
  "register.lineDuplicate": "bu cihaz numarası listede ya da kayıtlarda zaten var",
  "register.lineTooMany": "en fazla üç alan olabilir",
  "register.empty": "En az bir cihaz girin.",
  "register.count": "{count} cihaz kaydedilecek",
  "register.submit": "Kaydet",
  "register.resultTitle": "{count} cihaz kaydedildi",
  "register.secretWarning": "Gizli anahtarlar ve etiket kodları yalnızca şimdi gösteriliyor. Pencereyi kapatmadan önce CSV olarak indirin ya da kopyalayın; sonradan tekrar görüntülenemez.",
  "register.partialFailure": "{device} kaydedilemedi: {reason} Bu satır ve sonrakiler işlenmedi.",
  "register.downloadCsv": "CSV indir",
  "register.labelHint": "Gizli anahtar cihaza yüklenir. Etiket kodu cihazın etiketine basılır; müşteri cihazı eklerken bu kodu kullanır.",
  "register.brokerNotSynced": "Kaydedildi ama MQTT sunucusuna aktarılamadı: {devices}. Bu cihazlar gösterilen anahtarla bağlanamaz; kurulumdan önce envanterden anahtarlarını yenileyin.",

  "secret.secret": "Gizli anahtar",
  "secret.claimCode": "Etiket kodu",
  "secret.copySecret": "{device} gizli anahtarını kopyala",
  "secret.copyCode": "{device} etiket kodunu kopyala",
  "secret.savedClose": "Kaydettim, kapat",

  "rotate.title": "{device} için gizli anahtar yenilensin mi?",
  "rotate.body": "Yeni bir gizli anahtar üretilecek. Eski anahtar hemen geçersiz olur; yeni anahtar yüklenene kadar cihaz bağlanamaz.",
  "rotate.submit": "Anahtarı yenile",
  "rotate.resultTitle": "{device} için yeni gizli anahtar",
  "rotate.warning": "Bu anahtar yalnızca şimdi gösteriliyor. Kopyalayıp cihaza yükleyin; sonradan tekrar görüntülenemez.",
  "rotate.brokerNotSynced": "Yeni anahtar kaydedildi ama MQTT sunucusuna aktarılamadı; cihaz bu anahtarla henüz bağlanamaz. Biraz sonra anahtarı yeniden yenileyin.",

  "revoke.title": "{device} engellensin mi?",
  "revoke.body": "Engellenen cihaz sunucuya bağlanamaz ve gönderdiği veriler kaydedilmez. Araç bağlantısı korunur; engeli daha sonra kaldırabilirsiniz.",
  "revoke.unTitle": "{device} için engel kaldırılsın mı?",
  "revoke.unBody": "Cihaz yeniden bağlanıp veri gönderebilir. Sunucu yapılandırmasına göre yeni bir gizli anahtar da üretilebilir; üretilirse yalnızca bir kez gösterilir.",
  "revoke.syncTitle": "MQTT sunucusu güncellenemedi",
  "release.brokerNotSynced": "{device} envantere alındı ve anahtarı iptal edildi, ancak MQTT sunucusu güncellenemedi; cihaz mevcut bağlantısını koruyabilir. Cihazı engelleyip engeli tekrar kaldırarak sunucuyu güncelleyebilirsiniz.",
  "revoke.brokerNotSynced": "{device} engellendi ve gönderdiği veriler artık kaydedilmiyor. Ancak MQTT sunucusu güncellenemedi; cihaz sunucuya bağlı kalmaya devam edebilir.",
  "revoke.unBrokerNotSynced": "{device} için engel kaldırıldı ama bu değişiklik MQTT sunucusuna aktarılamadı; cihaz henüz bağlanamayabilir. Bağlanabilmesi için anahtarını yenileyin.",
  "revoke.unSecretWarning": "Engel kaldırıldı. Eski anahtar artık geçersiz; bu yeni anahtarı cihaza yükleyin. Anahtar yalnızca şimdi gösteriliyor, sonradan tekrar görüntülenemez.",

  "release.title": "{device} envantere geri alınsın mı?",
  "release.body": "Cihaz {tenant} firmasından alınır ve bağlı olduğu araçtan ayrılır. Yeni bir etiket kodu üretilir, eskisi geçersiz olur. Cihazın gizli anahtarı da iptal edilir; başka bir müşteriye vermeden önce anahtarı yenileyip cihaza yükleyin.",
  "release.submit": "Envantere al",
  "release.resultTitle": "{device} envantere alındı",
  "release.warning": "Yeni etiket kodu yalnızca şimdi gösteriliyor. Cihazın etiketini bu kodla yenileyin.",

  "sites.add": "Saha ekle",
  "site.addChild": "Alt birim ekle",
  "site.parent": "Üst birim",
  "site.noParent": "Yok (ana saha)",
  "site.parentRequired": "Bir üst birim seçin.",
  "site.parentHintManager": "Ana saha açmak kiracı yöneticisi yetkisi gerektirir.",
  "site.rootLocked": "Ana sahaların yerini yalnızca kiracı yöneticisi değiştirebilir.",
  "site.lat": "Enlem",
  "site.lon": "Boylam",
  "site.latHint": "−90 ile 90 arası, ör. 40.7654",
  "site.lonHint": "−180 ile 180 arası, ör. 29.9432",
  "site.latInvalid": "Enlem −90 ile 90 arasında bir sayı olmalı.",
  "site.lonInvalid": "Boylam −180 ile 180 arasında bir sayı olmalı.",
  "site.coordPair": "Enlem ve boylamı birlikte girin.",
  "siteForm.createTitle": "Yeni saha veya birim",
  "siteForm.editTitle": "Sahayı düzenle",
  "siteDelete.title": "“{name}” silinsin mi?",
  "siteDelete.body": "Bu işlem geri alınamaz.",
  "siteDelete.hasChildren": "Bu sahanın alt birimleri var. Önce alt birimleri silin ya da başka bir sahaya taşıyın.",
  "siteDelete.hasVehicles": "Bu sahada kayıtlı araçlar var. Önce araçları başka bir sahaya taşıyın.",

  "vehicles.add": "Araç ekle",
  "vehicleForm.createTitle": "Yeni araç",
  "vehicleForm.editTitle": "{fleetNo} aracını düzenle",
  "vehicleForm.fleetNoTaken": "Bu filo numarası zaten kullanılıyor.",
  "vehicleForm.noBattery": "Belirtilmedi",
  "vehicleForm.batteryHint": "Elektrikli araçlarda akü gerilimi.",
  "vehicleForm.activeHint": "Kullanımdan çıkan araçları pasif yapın. Pasif araçlara cihaz bağlanamaz.",
  "vehicleForm.unauthorizedStart": "Kartsız çalıştırma alarmı",
  "vehicleForm.unauthorizedStartHint": "Kart okuyucusu takılı olmayan araçta kapatın.",
  "vehicleForm.unauthorizedStartNoReader": "Bu araca bağlı cihazda kart okuyucu yok, bu yüzden bu alarm oluşmaz.",

  "tenantForm.open": "Yeni firma",
  "tenantForm.title": "Yeni firma",
  "tenantForm.description": "Yeni bir müşteri firması (kiracı) açın. Sahaları ve kullanıcıları ardından ekleyebilirsiniz.",
  "tenantForm.name": "Firma adı",
  "tenantForm.nameTooShort": "Firma adı en az 2 karakter olmalı.",
  "tenantForm.slug": "Kısa ad",
  "tenantForm.slugHint": "Firmayı tanımlayan benzersiz kısa ad: küçük harf, rakam ve tire.",
  "tenantForm.slugInvalid": "Kısa ad küçük harf ya da rakamla başlamalı ve yalnızca küçük harf, rakam ve tire içermeli (2–41 karakter).",
  "tenantForm.slugTaken": "Bu kısa ad başka bir firmada kullanılıyor.",
  "tenantForm.submit": "Firmayı aç",

  "members.you": "(siz)",
  "members.changeRole": "Rolü değiştir",
  "members.remove": "Kullanıcıyı çıkar",
  "members.roleTitle": "{name} için rol",
  "members.adminNeedsAllSites": "önce saha kısıtını kaldırın",
  "members.removeTitle": "{name} çıkarılsın mı?",
  "members.removeBody": "Kullanıcı {tenant} firmasına erişimini kaybeder. Hesabı silinmez; gerekirse yeniden davet edebilirsiniz.",
  "members.adminSeatsNote": "Yönetici atamak, bir yöneticinin rolünü değiştirmek ya da yöneticiyi çıkarmak için Expartise ile iletişime geçin.",

  "invite.open": "Kullanıcı davet et",
  "invite.title": "Kullanıcı davet et",
  "invite.description": "{tenant} için bir davet bağlantısı oluşturun.",
  "invite.selectedSites": "Seçili sahalar",
  "invite.chooseSites": "En az bir saha seçin.",
  "invite.adminAllSites": "Yöneticiler her zaman tüm sahalara erişir.",
  "invite.scopeHint": "Bir sahaya erişim, o sahanın tüm alt birimlerini de kapsar.",
  "invite.submit": "Davet oluştur",
  "invite.createdTitle": "Davet oluşturuldu",
  "invite.createdBody": "{email} adresi {role} rolüyle davet edildi. Bağlantı {date} tarihine kadar geçerli.",
  "invite.link": "Davet bağlantısı",
  "invite.copyLink": "Davet bağlantısını kopyala",
  "invite.sendEmail": "E-postayla gönder",
  "invite.sendAgain": "Tekrar gönder",
  "invite.sending": "Gönderiliyor…",
  "invite.emailSent": "Davet e-postası {email} adresine gönderildi.",
  "invite.emailSentDemo": "(Demo modunda gerçek e-posta gönderilmez.)",
  "invite.sendHint": "Daveti buradan e-postayla gönderebilir ya da bağlantıyı kopyalayıp kendiniz iletebilirsiniz. Bağlantı yalnızca şimdi gösteriliyor; kaybederseniz yeni bir davet oluşturun.",

  "invitations.title": "Davetler",
  "invitations.empty": "Bu firmada henüz davet yok.",
  "invitations.status": "Durum",
  "invitations.expires": "Bitiş",
  "invitations.revoke": "İptal et",
  "invitations.revokeTitle": "{email} daveti iptal edilsin mi?",
  "invitations.revokeBody": "Bağlantı hemen geçersiz olur. Gerekirse yeni bir davet oluşturabilirsiniz.",
  "invitationStatus.pending": "Bekliyor",
  "invitationStatus.accepted": "Kabul edildi",
  "invitationStatus.revoked": "İptal edildi",
  "invitationStatus.expired": "Süresi doldu",

  "acceptInvite.title": "Davet",
  "acceptInvite.summary": "{tenant} sizi Forklift Takip Sistemi konsoluna {role} olarak davet etti.",
  "acceptInvite.expires": "Davet {date} tarihine kadar geçerli.",
  "acceptInvite.loadErrorBody": "Davet bilgileri alınamadı. Bağlantınızı kontrol edip sayfayı yenileyin.",
  "acceptInvite.unknownTitle": "Davet bulunamadı",
  "acceptInvite.unknownBody": "Bağlantı hatalı ya da eksik kopyalanmış olabilir. Sizi davet eden kişiden bağlantıyı yeniden isteyin.",
  "acceptInvite.acceptedTitle": "Bu davet zaten kabul edilmiş",
  "acceptInvite.acceptedBody": "{tenant} hesabınıza bağlı. Konsola giriş yaparak devam edebilirsiniz.",
  "acceptInvite.revokedTitle": "Bu davet iptal edilmiş",
  "acceptInvite.revokedBody": "Erişime hâlâ ihtiyacınız varsa {tenant} yöneticinizden yeni bir davet isteyin.",
  "acceptInvite.expiredTitle": "Bu davetin süresi dolmuş",
  "acceptInvite.expiredBody": "Davetler 7 gün geçerlidir. {tenant} yöneticinizden yeni bir davet isteyin.",
  "acceptInvite.signInLinkIntro": "Daveti kabul etmek için davetin gönderildiği e-posta adresini girin; size bir giriş bağlantısı gönderelim.",
  "acceptInvite.signInPasswordIntro": "Daveti kabul etmek için davetin gönderildiği hesapla giriş yapın.",
  "acceptInvite.usePassword": "Şifreniz var mı? Şifreyle giriş yapın",
  "acceptInvite.useLink": "E-posta ile giriş bağlantısı al",
  "acceptInvite.checkInbox": "Gelen kutunuzu kontrol edin",
  "acceptInvite.checkInboxBody": "{email} adresine bir giriş bağlantısı gönderdik. E-postadaki bağlantıya bu tarayıcıda tıklayın; bu sayfaya dönüp daveti kabul edebilirsiniz.",
  "acceptInvite.useOtherEmail": "Başka bir adres kullan",
  "acceptInvite.demoNote": "Demo modunda e-posta gönderilmez. Giriş ekranındaki örnek hesaplardan biriyle (şifre: demo) giriş yapabilirsiniz.",
  "acceptInvite.signedInAs": "{email} olarak oturum açtınız.",
  "acceptInvite.displayName": "Adınız",
  "acceptInvite.displayNameHint": "Diğer kullanıcılar sizi bu adla görür.",
  "acceptInvite.accept": "Daveti kabul et",
  "acceptInvite.wrongEmail": "Bu davet başka bir e-posta adresine gönderilmiş. Şu an {email} olarak oturum açtınız; davetin gönderildiği adresle giriş yapın.",
  "acceptInvite.switchAccount": "Farklı hesapla giriş yap",
  "acceptInvite.alreadyMember": "Bu firmaya zaten erişiminiz var.",
  "acceptInvite.toConsole": "Konsola git",

  "map.title": "Canlı harita",
  "map.subtitle": "{tenant} · araçların anlık durumu",
  "map.listLabel": "Araçlar",
  "map.search": "Filo no veya model ara",
  "map.filterLabel": "Duruma göre süz",
  "map.filter.all": "Tümü",
  "map.state.working": "Çalışıyor",
  "map.state.idle": "Rölanti",
  "map.state.off": "Kontak kapalı",
  "map.state.offline": "Çevrim dışı",
  "map.state.alarm": "Alarm",
  "map.noMatch": "Bu süzgece uyan araç yok.",
  "map.empty": "Takip edilen araç yok",
  "map.emptyBody": "Bir aracın haritada görünmesi için ona telematik ünite bağlayın (Cihazlar ekranı).",
  "map.noData": "Henüz veri gelmedi",
  "map.noPosition": "Konum yok",
  "map.stale": "Son bilinen konum",
  "map.feed.connecting": "Bağlanıyor…",
  "map.feed.live": "Canlı",
  "map.feed.reconnecting": "Bağlantı yeniden kuruluyor…",
  "map.loadError": "Canlı veriler yüklenemedi. Bir dakika içinde yeniden denenecek.",
  "map.mapError": "Harita altlığı yüklenemedi; araç listesi çalışmaya devam ediyor.",
  "map.fitAll": "Tümünü göster",
  "map.sitePin": "Saha: {name}",
  "map.vehiclePin": "{fleetNo}, {state}",
  "map.mapLabel": "Araç haritası",
  "map.detail.close": "Kapat",
  "map.detail.openVehicle": "Araç kaydını aç",
  "map.detail.ignition": "Kontak",
  "map.detail.seat": "Koltuk",
  "map.detail.belt": "Emniyet kemeri",
  "map.detail.speed": "Hız",
  "map.detail.operator": "Operatör kartı",
  "map.detail.lastData": "Son veri",
  "map.detail.positionAt": "Konum zamanı",
  "map.detail.lastEvent": "Son olay",
  "map.detail.link": "Bağlantı",
  "map.detail.supply": "Besleme gerilimi",
  "map.detail.device": "Cihaz",
  "map.value.on": "Açık",
  "map.value.off": "Kapalı",
  "map.value.occupied": "Dolu",
  "map.value.empty": "Boş",
  "map.value.fastened": "Takılı",
  "map.value.unfastened": "Takılı değil",
  "map.value.noCard": "Kart okutulmadı",
  "map.value.kmh": "{value} km/sa",
  "map.value.volts": "{value} V",
  "map.value.accuracy": "±{value} m",
  "map.event.impact": "Darbe",
  "map.event.tamper": "Müdahale",
  "map.event.seat_violation": "Koltuk ihlali",
  "map.event.belt_violation": "Kemer ihlali",
  "map.event.power_loss": "Güç kesildi",
  "map.event.power_restore": "Güç geri geldi",
  "map.event.card_ok": "Kartla çalıştırma",
  "map.event.card_denied": "Kart reddedildi",
  "map.event.logout": "Oturum kapandı",
  // Sprint 7a: module events
  "map.event.lift": "Kaldırma",
  "map.event.overload": "Aşırı yük",
  "map.event.charge_start": "Şarj başladı",
  "map.event.charge_end": "Şarj bitti",
  "map.event.deep_discharge": "Akü derin deşarj",
  "map.event.bat_overtemp": "Akü aşırı sıcaklık",
  "map.privacyNote": "Operatör kartı kişisel veridir; yalnızca son dört hanesi gösterilir.",
  "map.event.other": "Diğer olay",
  "map.value.rssi": "{value} dBm",
  "map.value.link.gsm": "GSM (2G/3G)",
  "map.value.link.lte": "GSM (4G/LTE)",
  "map.value.link.wifi": "Wi-Fi",
  "inventory.newClaimCode": "Etiket kodunu yenile",
  "newClaim.title": "{device} için yeni etiket kodu üretilsin mi?",
  "newClaim.body": "Etiket kaybolduysa kullanın. Yeni bir etiket kodu üretilir, eskisi geçersiz olur. Cihazın gizli anahtarı da iptal edilir; ardından anahtarı yenileyip cihaza yükleyin.",
  "newClaim.submit": "Yeni kod üret",
  "newClaim.resultTitle": "{device} için yeni etiket kodu",

  "error.card_in_use": "Bu kart numarası başka bir operatörde aktif. Önce o kartı kayıp ya da iptal olarak işaretleyin.",
  "error.invalid_card": "Kart numarası geçersiz. 8–20 haneli onaltılık (0–9, A–F) bir numara girin.",
  "error.invalid_permission": "Yetki için ya bir saha ya da tek bir araç seçin.",
  "error.invalid_left_on": "Son çalışma günü bir aydan daha eski olamaz. Tarihi kontrol edin; yanlış bir tarih kişisel verilerin erken silinmesine yol açar.",
  "error.operator_left": "Bu operatörün kişisel verileri silinmiş (KVKK). Kayıt artık değiştirilemez.",
  "error.invalid_contact": "Bu kişi sahayı göremiyor. Gece sorumlusu, firmanın bu sahayı görebilen bir kullanıcısı olmalı.",
  "error.invalid_alert_settings": "Mesai ayarı geçersiz. En az bir çalışma günü seçin; başlangıç saati bitiş saatinden önce olmalı.",
  "error.already_acknowledged": "Bu alarm zaten onaylanmış.",
  "error.note_too_long": "Not en fazla 500 karakter olabilir.",
  "map.value.unknownCard": "tanımsız kart",
  "opStatus.active": "Aktif",
  "opStatus.expiring": "Belgesi bitiyor",
  "opStatus.suspended": "Askıda",
  "opStatus.inactive": "Pasif",
  "opStatus.left": "Ayrıldı",
  "operators.title": "Operatörler",
  "operators.subtitle": "{count} operatör",
  "operators.add": "Operatör ekle",
  "operators.filtersLabel": "Operatör filtreleri",
  "operators.search": "Ad veya sicil no ile ara",
  "operators.filterStatus": "Durum",
  "operators.allCurrent": "Ayrılanlar hariç tümü",
  "operators.empty": "Henüz operatör yok",
  "operators.emptyManager": "Operatör ekleyin, kartını tanımlayın ve hangi araçları kullanabileceğini belirleyin.",
  "operators.emptyViewer": "Operatörleri İSG sorumlusu veya filo yöneticisi ekler.",
  "operators.noMatch": "Filtreye uyan operatör yok",
  "operators.readOnly": "Operatörleri görüntüleyebilirsiniz. Kart, belge ve yetki işlemleri İSG sorumlusu ve üzeri rollere açıktır.",
  "operators.back": "Operatörlere dön",
  "operator.fullName": "Ad soyad",
  "operator.employeeNo": "Sicil no",
  "operator.site": "Bağlı olduğu saha",
  "operator.siteAll": "Tüm firma",
  "operator.siteHint": "Operatörü kimlerin görebileceğini belirler. Hangi araçları kullanabileceği yetkilerden gelir.",
  "operator.status": "Durum",
  "operator.cards": "Kartlar",
  "operator.documents": "Belgeler",
  "operator.permissions": "Yetkiler",
  "operator.nextExpiry": "En yakın belge bitişi",
  "operator.identity": "Bilgiler",
  "operator.leftOn": "Son çalışma günü",
  "operator.leftOnHint": "Operatör bu tarihin sonuna kadar araç kullanabilir. Kişisel verileri 6 ay sonra otomatik silinir.",
  "operator.authorizedVehicles": "Bugün kullanabildiği araçlar",
  "operator.noVehicles": "Şu an kullanabildiği araç yok",
  "operator.addTitle": "Operatör ekle",
  "operator.editTitle": "Operatörü düzenle",
  "operator.kvkkNote": "Ad ve sicil no kişisel veridir (KVKK). İşten ayrılan operatörün verileri 6 ay sonra otomatik silinir.",
  "operator.activeLabel": "Aktif (pasif operatör hiçbir araçta kart okutamaz)",
  "operator.leave": "İşten ayrıldı",
  "operator.leaveTitle": "{name} işten ayrıldı olarak işaretlensin mi?",
  "operator.leaveDescription": "Son çalışma gününden sonra kartları hiçbir araçta çalışmaz.",
  "operator.leaveSubmit": "Ayrıldı olarak işaretle",
  "operator.suspendedNote": "Zorunlu bir belgenin süresi doldu. Operatör belge yenilenene kadar hiçbir araçta kart okutamaz.",
  "operator.leftNote": "Son çalışma günü: {day}. Kişisel veriler bu tarihten 6 ay sonra otomatik silinecek.",
  "operator.anonymizedNote": "Bu operatörün kişisel verileri KVKK gereği silindi. Kayıt yalnızca geçmiş raporlar için tutuluyor.",
  "operator.notFound": "Operatör bulunamadı",
  "card.uid": "Kart numarası",
  "card.tech": "Kart tipi",
  "card.status": "Durum",
  "card.operator": "Operatör",
  "card.createdAt": "Eklendi",
  "card.add": "Kart ekle",
  "card.addTitle": "{name} için kart ekle",
  "card.addDescription": "Kart numarasını okuyucunun gösterdiği şekilde girin; boşluk ve iki nokta işaretleri kendiliğinden temizlenir.",
  "card.uidHint": "8–20 haneli onaltılık numara, örneğin 04A1B2C3",
  "card.uidFormat": "8–20 haneli onaltılık (0–9, A–F) bir numara girin.",
  "card.uidNormalized": "Kaydedilecek numara: {uid}",
  "card.none": "Tanımlı kart yok",
  "card.markLost": "Kayıp",
  "card.revoke": "İptal et",
  "card.lostTitle": "Kart kayıp olarak işaretlensin mi?",
  "card.revokeTitle": "Kart iptal edilsin mi?",
  "card.statusBody": "{name} adına kayıtlı {uid} numaralı kart birkaç saniye içinde tüm araçlarda geçersiz olur. Bu işlem geri alınamaz; kart bulunursa yeniden eklenebilir.",
  "cardStatus.active": "Aktif",
  "cardStatus.lost": "Kayıp",
  "cardStatus.revoked": "İptal",
  "cardTech.mifare": "MIFARE (13,56 MHz)",
  "cardTech.hid": "HID",
  "cardTech.em125": "125 kHz (EM)",
  "cards.title": "Kartlar",
  "cards.subtitle": "{count} aktif kart",
  "cards.filtersLabel": "Kart filtreleri",
  "cards.search": "Kart numarası ile ara",
  "cards.showInactive": "Kayıp ve iptal kartları da göster",
  "cards.empty": "Henüz kart yok",
  "cards.emptyHint": "Kartlar operatör sayfasından eklenir.",
  "cards.noMatch": "Aramaya uyan kart yok",
  "cards.note": "Bir kartı kayıp ya da iptal olarak işaretlediğinizde araçlara birkaç saniye içinde iletilir. Çevrim dışı araç, bağlandığı ilk anda güncel listeyi alır.",
  "doc.kind": "Belge",
  "doc.label": "Açıklama",
  "doc.validUntil": "Geçerlilik bitişi",
  "doc.required": "Zorunlu",
  "doc.requiredLabel": "Zorunlu belge",
  "doc.requiredHint": "Zorunlu bir belgenin süresi dolarsa operatör otomatik olarak askıya alınır. Konsol 30, 15 ve 7 gün kala uyarır.",
  "doc.add": "Belge ekle",
  "doc.addTitle": "Belge ekle",
  "doc.editTitle": "Belgeyi düzenle",
  "doc.none": "Kayıtlı belge yok",
  "doc.expired": "Süresi doldu",
  "doc.withinDays": "{days} gün içinde bitiyor",
  "doc.delete": "Belgeyi sil",
  "doc.deleteTitle": "Belge silinsin mi?",
  "doc.deleteBody": "“{kind}” kaydı silinecek. Zorunlu bir belgeyse operatörün araç yetkisi bu belgeye bağlı olmaktan çıkar.",
  "docKind.operator_certificate": "Operatör belgesi",
  "docKind.driving_licence": "Sürücü belgesi",
  "docKind.training": "Eğitim sertifikası",
  "docKind.other": "Diğer",
  "perm.operator": "Operatör",
  "perm.scope": "Kapsam",
  "perm.scopeSite": "{site} (tüm araçlar)",
  "perm.scopeSiteType": "{site} · yalnızca {type}",
  "perm.scopeVehicle": "Yalnızca {vehicle}",
  "perm.scopeSiteOption": "Saha (alt alanlar dahil; sonradan eklenen araçlar da kapsanır)",
  "perm.scopeVehicleOption": "Tek bir araç",
  "perm.site": "Saha",
  "perm.siteHint": "Seçilen sahanın tüm alt alanları dahildir.",
  "perm.vehicleType": "Araç tipi",
  "perm.allTypes": "Tüm tipler",
  "perm.vehicle": "Araç",
  "perm.validUntil": "Bitiş tarihi",
  "perm.validUntilHint": "Boş bırakırsanız süresiz olur. Tarih, araç çevrim dışı olsa bile cihazın kendisi tarafından uygulanır.",
  "perm.openEnded": "Süresiz",
  "perm.expired": "Süresi doldu",
  "perm.add": "Yetki ver",
  "perm.addTitle": "Yetki ver",
  "perm.addTitleFor": "{name} için yetki ver",
  "perm.addDescription": "Operatör, kartı aktif ve zorunlu belgeleri geçerli olduğu sürece bu araçları çalıştırabilir.",
  "perm.none": "Henüz yetki verilmedi",
  "perm.remove": "Yetkiyi kaldır",
  "perm.removeTitle": "Yetki kaldırılsın mı?",
  "perm.removeBody": "{name} için “{scope}” yetkisi kaldırılacak. Araçlar birkaç saniye içinde güncellenir.",
  "permissions.title": "Yetkiler",
  "permissions.subtitle": "Hangi operatörün hangi araçları kullanabileceği",
  "permissions.showExpired": "Süresi dolanları da göster",
  "permissions.empty": "Henüz yetki yok",
  "permissions.emptyHint": "Bir operatöre saha, araç tipi veya tek bir araç için yetki verin.",
  "permissions.note": "Değişiklikler birkaç saniye içinde araçlara iletilir. Çevrim dışı araçlar bağlandıkları ilk anda güncel listeyi alır.",
  "vehicleOps.title": "Bu aracı kullanabilecek operatörler",
  "vehicleOps.until": "Yetki bitişi",
  "vehicleOps.none": "Bugün bu aracı kullanabilecek operatör yok.",
  "vehicleOps.note": "Liste yetkilerden, aktif kartlardan ve belge sürelerinden hesaplanır; cihaza aynısı gönderilir.",
  "authlist.column": "Kart listesi",
  "authlist.synced": "Güncel",
  "authlist.pending": "Gönderiliyor",
  "authlist.error": "Hata",
  "authlist.none": "Gönderilmedi",
  "authlist.syncedAt": "Cihaz listeyi onayladı ({when})",
  "authlist.pendingHint": "Güncel liste cihazın onayını bekliyor. Çevrim dışı cihaz bağlandığında alır.",
  "authlist.errorHint": "Liste iletilemedi: {error}. Her dakika yeniden denenir.",
  "authlist.noneHint": "Bu cihaza henüz liste gönderilmedi.",
  "authlist.noReader": "Kart okuyucu yok",
  "authlist.noReaderHint": "Bu cihazda kart okuyucu yok. Bu yüzden cihaza kart listesi gönderilmez, kartsız çalıştırma ya da yetkisiz kart alarmı da oluşmaz.",
  "authlist.syncNow": "Listeleri şimdi gönder",
  "authlist.syncHint": "Değişiklikler zaten dakikada bir gönderilir; beklemek istemezseniz kullanın.",
  "authlist.syncDone": "Listeler gönderildi.",
  "authlist.syncFailed": "Listeler şu an gönderilemedi; bir dakika içinde otomatik denenir.",

  /* ---- Sprint 6a: alarms (ADR 0011) ---- */
  "alarm.type.impact": "Darbe",
  "alarm.type.unauthorized_start": "Kartsız çalıştırma",
  "alarm.type.card_denied": "Yetkisiz kart denemesi",
  "alarm.type.seat_violation": "Koltuk ihlali",
  "alarm.type.belt_violation": "Kemer ihlali",
  "alarm.type.tamper": "Müdahale",
  "alarm.type.power_loss": "Güç kesildi",
  "alarm.type.geofence_enter": "Yasak bölgeye giriş",
  "alarm.type.geofence_exit": "Çalışma alanından çıkış",
  "alarm.type.geofence_dwell": "Bölgede süre aşımı",
  // Sprint 7a: module alarms
  "alarm.type.overload": "Aşırı yük",
  "alarm.type.deep_discharge": "Akü derin deşarj",
  "alarm.type.bat_overtemp": "Akü aşırı sıcaklık",
  "alarm.type.dvr_storage": "Kayıt cihazı: kayıt ortamı sorunu",
  "alarm.type.dvr_camera": "Kayıt cihazı: kamera kanalı sorunlu veya kayıt yapmıyor",
  "alarm.type.device_output_control": "Cihazda darbe sonrası çıkış kontrolü açık",
  "alarm.type.other": "Diğer olay",
  "alarm.typeWithSeverity": "{type} · Seviye {level}",
  "alarm.status.open": "Açık",
  "alarm.status.acknowledged": "Onaylandı",
  "alarm.badge.offHours": "Mesai dışı",
  "alarm.badge.delayed": "Gecikmeli",
  "alarm.badge.offHoursHint": "Olay sahanın mesai saatleri dışında oldu.",
  "alarm.badge.delayedHint": "Cihaz bu olayı bağlantısı geri gelince geç gönderdi.",
  "alarm.badge.timeUnknown": "Zamanı belirsiz",
  "alarm.badge.timeUnknownHint": "Cihaz saati doğrulanamadı; gösterilen zaman olayın sisteme ulaştığı zamandır.",
  "alarm.badge.repeat": "×{count} tekrar, son: {time}",
  "alarm.badge.repeatNoTime": "×{count} tekrar",
  "alarm.badge.repeatHint": "Aynı olay bu araçta 30 dakika içinde yeniden oldu; yeni alarm ve bildirim oluşturulmadı.",
  "alarm.timeUnknown": "Olay zamanı belirsiz (cihaz saati doğrulanamadı)",
  "alarm.noBlock": "Araç bloke edilmez; darbe yalnızca bildirimdir.",

  "alarms.title": "Alarmlar",
  "alarms.subtitle": "Darbe ve güvenlik olayları. Saatler Türkiye saatiyle gösterilir.",
  "alarms.filtersLabel": "Alarm filtreleri",
  "alarms.filter.status": "Durum",
  "alarms.filter.open": "Açık",
  "alarms.filter.acknowledged": "Onaylanan",
  "alarms.filter.all": "Tümü",
  "alarms.filter.type": "Tür",
  "alarms.filter.allTypes": "Tüm türler",
  "alarms.filter.site": "Saha",
  "alarms.filter.allSites": "Tüm sahalar",
  "alarms.filter.from": "Başlangıç tarihi",
  "alarms.filter.to": "Bitiş tarihi",
  "alarms.filter.clear": "Filtreleri temizle",
  "alarms.filter.dateError": "Bitiş tarihi başlangıçtan önce olamaz.",
  "alarms.shown": "Gösterilen: {count}",
  "alarms.limitNote": "En yeni {limit} alarm gösteriliyor. Daha eskilerini görmek için tarih aralığını daraltın.",
  "alarms.col.time": "Zaman",
  "alarms.col.type": "Tür",
  "alarms.col.vehicle": "Araç",
  "alarms.col.site": "Saha",
  "alarms.col.operator": "Operatör",
  "alarms.col.status": "Durum",
  "alarms.emptyOpen": "Açık alarm yok.",
  "alarms.empty": "Bu filtrelere uyan alarm yok.",
  "alarms.loadError": "Alarmlar yüklenemedi.",
  "alarms.rowLink": "{type} alarmının ayrıntıları, {time}",

  "alarmDetail.back": "Alarmlara dön",
  "alarmDetail.heading": "{type} · {vehicle}",
  "alarmDetail.notFound": "Alarm bulunamadı",
  "alarmDetail.notFoundHint": "Alarm silinmiş olabilir ya da bu sahayı görme yetkiniz olmayabilir.",
  "alarmDetail.facts": "Olay bilgileri",
  "alarmDetail.occurredAt": "Olay zamanı",
  "alarmDetail.receivedAt": "Sisteme ulaştığı zaman",
  "alarmDetail.type": "Tür",
  "alarmDetail.vehicle": "Araç",
  "alarmDetail.site": "Saha",
  "alarmDetail.device": "Cihaz",
  "alarmDetail.operator": "Operatör",
  "alarmDetail.noOperator": "Kart okutulmamış",
  "alarmDetail.workTime": "Mesai",
  "alarmDetail.inHours": "Mesai içinde",
  "alarmDetail.offHours": "Mesai dışında",
  "alarmDetail.delayedNote": "Gecikmeli: olay {time} tarihinde oldu, sisteme {received} tarihinde ulaştı.",
  "alarmDetail.timeUnknownNote": "Olay zamanı belirsiz (cihaz saati doğrulanamadı). Alarm, olayın sisteme ulaştığı zamanla ve aracın şu anki sahasıyla kaydedildi.",
  "alarmDetail.repeats": "Tekrar",
  "alarmDetail.notifyError": "Bu alarm için otomatik bildirim gönderilemedi. İlgili kişileri ayrıca haberdar edin.",
  "alarmDetail.noRecipients": "Bu alarm kimseye bildirilmedi: sahada bildirim alacak kullanıcı yok. Firmaya İSG sorumlusu, filo yöneticisi veya firma yöneticisi ekleyin.",
  "alarmDetail.status": "Durum",
  "alarmDetail.timeZoneNote": "Saatler Türkiye saatidir.",

  "alarmNotify.title": "Kimlere bildirildi",
  "alarmNotify.none": "Görebileceğiniz bir bildirim kaydı yok.",
  "alarmNotify.ownOnly": "Yalnızca size gönderilen bildirimler görünüyor. Sahadaki tüm bildirimleri İSG sorumlusu ve üzeri roller görür.",
  "alarmNotify.recipient": "Alıcı",
  "alarmNotify.channel": "Kanal",
  "alarmNotify.kind": "Bildirim",
  "alarmNotify.status": "Durum",
  "alarmNotify.sentAt": "Gönderim",
  "alarmNotify.you": "{name} (siz)",
  "alarmNotify.unknownUser": "Ekip üyesi",
  "alarmNotify.dueAt": "Planlanan: {time}",
  "alarmChannel.email": "E-posta",
  "alarmChannel.sms": "SMS",
  "alarmChannel.push": "Anlık bildirim",

  /* Sprint 7b (ADR 0019): PWA and web push */
  "nav.profile": "Profilim",
  "profile.title": "Profilim",
  "profile.subtitle": "Hesap bilgileriniz, şifreniz ve bildirim alan cihazlarınız",
  "profile.account": "Hesap",
  "profile.name": "Ad",
  "profile.email": "E-posta",
  "password.title": "Şifre",
  "password.intro": "Konsola e-posta ve şifreyle girmek için şifre belirleyin. Şimdiye kadar yalnızca e-posta bağlantısıyla girdiyseniz de buradan şifre oluşturabilirsiniz.",
  "password.new": "Yeni şifre",
  "password.repeat": "Yeni şifre (tekrar)",
  "password.show": "Şifreyi göster",
  "password.rules": "En az {min}, en fazla {max} karakter; e-posta adresinizle aynı olamaz. Uzun bir cümle veya harf, rakam ve işaret karışımı en güvenlisidir.",
  "password.strength.weak": "Güç: zayıf",
  "password.strength.fair": "Güç: orta",
  "password.strength.strong": "Güç: güçlü",
  "password.submit": "Şifreyi kaydet",
  "password.updated": "Şifreniz güncellendi.",
  "password.err.required": "Yeni şifreyi girin.",
  "password.err.tooShort": "Şifre en az {min} karakter olmalı.",
  "password.err.tooLong": "Şifre en fazla {max} karakter olabilir (Türkçe harfler iki karakter sayılır).",
  "password.err.sameAsEmail": "Şifre e-posta adresinizle aynı olamaz.",
  "password.err.repeatRequired": "Şifreyi tekrar girin.",
  "password.err.mismatch": "İki şifre birbirini tutmuyor.",
  "push.title": "Bildirimler",
  "push.intro": "Size e-postayla gelen anlık alarm bildirimleri, bildirimleri açtığınız cihazlara da gelir. Sabah özeti ve belge hatırlatmaları yalnızca e-postayla gelir. Kilit ekranında görüneceği için bildirimde operatör adı yer almaz.",
  "push.disabledAdmin": "Anlık bildirim sunucuda henüz yapılandırılmadı (VAPID anahtarları eksik). GitHub Actions'ta “VAPID keys” iş akışını çalıştırın (docs/ops/cloud-setup.md, bölüm 4b). E-posta bildirimleri çalışmaya devam ediyor.",
  "push.disabledUser": "Anlık bildirim şu anda kullanılamıyor. Alarm bildirimleri e-postayla gelmeye devam ediyor.",
  "push.configError": "Bildirim ayarları yüklenemedi.",
  "push.env.ios_install": "iPhone veya iPad'de bildirim almak için FTS'yi önce ana ekrana ekleyin: Safari'de Paylaş → Ana Ekrana Ekle. Sonra uygulamayı ana ekrandan açıp bu sayfaya dönün.",
  "push.env.denied": "Bu tarayıcıda FTS için bildirim izni engellenmiş. Tarayıcının site ayarlarından bildirimlere izin verip sayfayı yenileyin.",
  "push.env.unsupported": "Bu tarayıcı anlık bildirimleri desteklemiyor. Chrome, Edge, Firefox veya Safari'nin güncel sürümünü kullanın.",
  "push.thisDevice": "Bu cihaz",
  "push.thisDeviceOn": "Bu cihazda bildirimler açık.",
  "push.thisDeviceOff": "Bu cihazda bildirimler kapalı.",
  "push.enable": "Bu cihazda bildirimleri aç",
  "push.disable": "Bu cihazda kapat",
  "push.enabled": "Bu cihazda bildirimler açıldı.",
  "push.disabled": "Bu cihazda bildirimler kapatıldı.",
  "push.permissionNote": "Tarayıcı izin isteyecek.",
  "push.notRemembered": "Bu cihazda oturum hatırlanmıyor; ortak cihazlarda bildirim açılamaz. Kendi cihazınızda bildirim almak için çıkış yapıp \"Beni hatırla\" işaretliyken yeniden giriş yapın.",
  "push.stale": "Bildirimler yenilenmeli: sunucunun bildirim anahtarı değişti, bu cihaz şu anda bildirim almıyor.",
  "push.renew": "Bildirimleri yenile",
  "push.devices": "Bildirim alan cihazlarım",
  "push.noDevices": "Henüz bildirim açılmış bir cihazınız yok.",
  "push.added": "Eklendi: {date}",
  "push.lastOk": "Son başarılı gönderim: {date}",
  "push.failures": "{n} başarısız deneme",
  "push.remove": "Kaldır",
  "push.removeTitle": "Cihaz kaldırılsın mı?",
  "push.removeText": "{name} artık bildirim almayacak.",
  "push.test": "Test bildirimi gönder",
  "push.testResult": "Test bildirimi gönderildi: {sent} cihaz. Ulaşmayan: {failed}. Kaldırılan: {removed}.",
  "push.err.denied": "Bildirim izni verilmedi.",
  "push.err.noSw": "Bildirim servisi bu sayfada hazır değil. Sayfayı yenileyip tekrar deneyin.",
  "push.err.subscribeFailed": "Bu cihaz bildirim servisine kaydedilemedi. Tekrar deneyin.",
  "error.network": "Bağlantı yok. İnternet bağlantınızı kontrol edip tekrar deneyin.",
  "error.weak_password": "Bu şifre çok zayıf veya kolay tahmin edilebilir. Daha uzun ya da harf, rakam ve işaret karışık bir şifre seçin.",
  "error.same_password": "Yeni şifre mevcut şifrenizle aynı. Farklı bir şifre seçin.",
  "error.reauthentication_needed": "Güvenlik için çıkış yapıp e-posta bağlantısıyla tekrar girin, sonra şifrenizi değiştirin.",
  "error.not_in_demo": "Demo modunda şifre değiştirilemez; demo hesapları sabit bir örnek şifre kullanır.",
  "error.push_disabled": "Anlık bildirim sunucuda yapılandırılmadı.",
  "error.invalid_push_subscription": "Bu cihazın bildirim kaydı geçersiz. Tekrar deneyin.",
  "error.push_device_limit": "En fazla 10 cihazda bildirim açılabilir. Önce kullanmadığınız bir cihazı kaldırın.",
  "pwa.offline": "Bağlantı yok",
  "pwa.updateReady": "Yeni sürüm var.",
  "pwa.reload": "Yenile",
  "pwa.iosHint": "Ana ekrana eklemek için Safari'de Paylaş → Ana Ekrana Ekle'ye dokunun.",
  "lazy.loadError": "Bu bölüm yüklenemedi. Sayfayı yenileyin.",
  "lazy.reload": "Sayfayı yenile",
  "pwa.dismiss": "Kapat",
  "cf.offline": "Bağlantı yok. İnternet bağlantınızı kontrol edip tekrar deneyin.",
  "alarmKind.immediate": "Anlık",
  "alarmKind.digest_item": "Sabah özeti",
  "alarmKind.document_reminder": "Belge hatırlatması",
  "alarmNStatus.pending": "Sırada",
  "alarmNStatus.sending": "Gönderiliyor",
  "alarmNStatus.sent": "Gönderildi",
  "alarmNStatus.failed": "Gönderilemedi",
  "alarmNStatus.skipped": "Gönderilmedi",

  "alarmAck.title": "Onay",
  "alarmAck.button": "Alarmı onayla",
  "alarmAck.noteLabel": "Not",
  "alarmAck.noteHint": "Ne yapıldığını kısaca yazın (en fazla 500 karakter). Onay geri alınamaz.",
  "alarmAck.tooLong": "Not en fazla 500 karakter olabilir.",
  "alarmAck.done": "Alarm onaylandı.",
  "alarmAck.by": "Onaylayan",
  "alarmAck.at": "Onay zamanı",
  "alarmAck.note": "Not",
  "alarmAck.noNote": "Not yazılmadı",
  "alarmAck.waiting": "Bu alarm henüz onaylanmadı.",
  "alarmAck.needsRole": "Alarmları İSG sorumlusu ve üzeri roller onaylar.",

  "map.detail.openAlarm": "Alarmı aç",

  "day.short.1": "Pzt",
  "day.short.2": "Sal",
  "day.short.3": "Çar",
  "day.short.4": "Per",
  "day.short.5": "Cum",
  "day.short.6": "Cmt",
  "day.short.7": "Paz",
  "day.long.1": "Pazartesi",
  "day.long.2": "Salı",
  "day.long.3": "Çarşamba",
  "day.long.4": "Perşembe",
  "day.long.5": "Cuma",
  "day.long.6": "Cumartesi",
  "day.long.7": "Pazar",

  "siteAlerts.title": "Bildirim ayarları",
  "siteAlerts.loadError": "Bildirim ayarları yüklenemedi.",
  "siteAlerts.readOnly": "Bu ayarları filo yöneticisi ve firma yöneticisi değiştirir.",
  "siteAlerts.inherited": "Üst sahadan devralındı: {site}",
  "siteAlerts.own": "Bu sahaya özel",
  "siteAlerts.hours.title": "Mesai saatleri",
  "siteAlerts.hours.summary": "{days} · {start}–{end}",
  "siteAlerts.hours.summaryAllDay": "{days} · tüm gün",
  "siteAlerts.hours.allDay": "Tüm gün",
  "siteAlerts.hours.allDayHint": "00:00–24:00. Bütün günler de seçiliyse alarmlar hiçbir zaman mesai dışı sayılmaz.",
  "siteAlerts.hours.default": "Varsayılan ayar (Pzt–Cum 08:00–18:00)",
  "siteAlerts.hours.tz": "Saat dilimi: Türkiye (İstanbul). Resmî tatiller şimdilik hesaba katılmaz.",
  "siteAlerts.hours.edit": "Mesai saatlerini düzenle",
  "siteAlerts.hours.override": "Bu saha için ayrı saat belirle",
  "siteAlerts.hours.resetParent": "Üst sahanın saatlerine dön",
  "siteAlerts.hours.resetDefault": "Varsayılan saatlere dön",
  "siteAlerts.hours.resetTitle": "Sahaya özel saatler kaldırılsın mı?",
  "siteAlerts.hours.resetBody": "{site} sahasına özel mesai saatleri silinir. Saha bundan sonra üst sahanın saatlerini, o da yoksa varsayılan saatleri kullanır.",
  "siteAlerts.hours.dialogTitle": "Mesai saatleri · {site}",
  "siteAlerts.hours.days": "Çalışma günleri",
  "siteAlerts.hours.start": "Başlangıç saati",
  "siteAlerts.hours.end": "Bitiş saati",
  "siteAlerts.hours.daysRequired": "En az bir gün seçin.",
  "siteAlerts.hours.endAfterStart": "Bitiş saati başlangıçtan sonra olmalı.",
  "siteAlerts.hours.childNote": "Kendi ayarı olmayan alt sahalar da bu saatleri kullanır.",
  "siteAlerts.night.title": "Gece sorumluları",
  "siteAlerts.night.hint": "Mesai dışında olan darbeler bu kişilere hemen e-postayla gider.",
  "siteAlerts.night.none": "Tanımlı değil: mesai dışı darbe gündüz alıcılarına gider",
  "siteAlerts.night.edit": "Gece sorumlularını düzenle",
  "siteAlerts.night.reset": "Sahaya özel listeyi kaldır",
  "siteAlerts.night.resetTitle": "Sahaya özel gece sorumluları kaldırılsın mı?",
  "siteAlerts.night.resetBody": "{site} sahası bundan sonra üst sahanın gece sorumlularını kullanır. Hiçbir üst sahada tanım yoksa mesai dışı darbeler gündüz alıcılarına gider.",
  "siteAlerts.night.dialogTitle": "Gece sorumluları · {site}",
  "siteAlerts.night.pick": "Bu sahayı görebilen kullanıcılar",
  "siteAlerts.night.pickHint": "Kimseyi seçmezseniz saha, üst sahanın gece sorumlularını kullanır.",
  "siteAlerts.inheritedHidden": "Üst sahadan devralındı",
  "siteAlerts.night.noCandidates": "Seçilebilecek kullanıcı yok.",
  "siteAlerts.preview.title": "Şu an bir olay olsa",
  "siteAlerts.preview.inHours": "Şu an mesai içi ({time}).",
  "siteAlerts.preview.offHours": "Şu an mesai dışı ({time}).",
  "siteAlerts.preview.impactNow": "Darbe olursa hemen e-posta alır: {who}.",
  "siteAlerts.preview.othersNow": "Diğer alarmlar da hemen gündüz alıcılarına gider.",
  "siteAlerts.preview.impactFallback": "Gece sorumlusu tanımlı olmadığı için darbe gündüz alıcılarına gider.",
  "siteAlerts.preview.impactDigest": "Hemen e-posta almayan gündüz alıcıları darbeyi {when} sabah özetinde görür.",
  "siteAlerts.preview.othersDigest": "Diğer alarmlar {when} sabah özetiyle gelir: {who}.",
  "siteAlerts.preview.noDigest": "Çalışma günü seçilmediği için sabah özeti gönderilmez.",
  "siteAlerts.preview.dayGroup": "İSG sorumlusu veya filo yöneticisi rolündeki {count} kişi",
  "siteAlerts.preview.dayGroupOne": "İSG sorumlusu veya filo yöneticisi rolündeki 1 kişi",
  "siteAlerts.preview.adminsFallback": "{count} firma yöneticisi",
  "siteAlerts.preview.adminsFallbackOne": "1 firma yöneticisi",
  "siteAlerts.preview.dayGroupWithAdmins": "İSG sorumlusu, filo yöneticisi veya yönetici rolündeki {count} kişi",
  "siteAlerts.preview.dayGroupWithAdminsOne": "İSG sorumlusu, filo yöneticisi veya yönetici rolündeki 1 kişi",
  "siteAlerts.preview.impactAdminsToo": "Darbe aynı anda {count} firma yöneticisine de gider.",
  "siteAlerts.preview.impactAdminsTooOne": "Darbe aynı anda 1 firma yöneticisine de gider.",
  "siteAlerts.preview.adminsCopy": "Firma yöneticileri her alarmın kopyasını da alır (Kullanıcılar ve roller ekranındaki ayar).",
  "siteAlerts.preview.noRecipients": "Bu sahada bildirim alacak kullanıcı tanımlı değil; darbe kimseye gitmez.",
  "siteAlerts.preview.impactNobody": "Darbe olursa kimseye e-posta gitmez.",
  "siteAlerts.preview.othersNobody": "Diğer alarmlar da kimseye gitmez.",
  "siteAlerts.preview.othersDigestNobody": "Diğer alarmların {when} sabah özeti kimseye gitmez.",
  // ADR 0014: live watch
  "error.device_offline": "Cihaz çevrim dışı; canlı izleme cihaz bağlanınca başlatılabilir.",
  "error.too_many_live_watches": "Aynı anda en fazla 5 araç canlı izlenebilir. Biri bitince tekrar deneyin.",
  "liveWatch.waiting": "Cihaz bekleniyor",
  "liveWatch.waitingLabel": "Canlı izleme komutu gönderildi, cihazın onayı bekleniyor",
  "liveWatch.start": "Canlı izle (10 dk)",
  "liveWatch.starting": "Başlatılıyor…",
  "liveWatch.active": "Canlı izleniyor · {time}",
  "liveWatch.activeLabel": "Canlı izleme açık, kalan süre {time}",
  "liveWatch.tooSoon": "Bu araç için az önce canlı izleme istendi. 30 saniye sonra tekrar deneyin.",
  "liveWatch.hint": "Araç 10 dakika boyunca saniyede bir konum gönderir, sonra normal aralığa döner. Aracın çalışmasına hiçbir etkisi yoktur.",

  "geofence.title": "Bölgeler",
  "geofence.add": "Bölge ekle",
  "geofence.intro": "Yasak bölge, çalışma alanı veya süre sınırı tanımlayın; kural bozulursa alarm oluşur ve bildirim kurallarına göre iletilir.",
  "geofence.empty": "Bu sahada tanımlı bölge yok.",
  "geofence.loadError": "Bölgeler yüklenemedi.",
  "geofence.tableCaption": "{site} bölgeleri",
  "geofence.name": "Ad",
  "geofence.nameHint": "Haritada ve alarmlarda bu ad görünür. Örnek: Yaya yolu – ana giriş.",
  "geofence.kind": "Tür",
  "geofence.shape": "Şekil",
  "geofence.vehicleTypes": "Araç tipleri",
  "geofence.status": "Durum",
  "geofence.actions": "İşlemler",
  "geofence.active": "Etkin",
  "geofence.inactive": "Pasif",
  "geofence.editNamed": "{name} bölgesini düzenle",
  "geofence.deleteNamed": "{name} bölgesini sil",
  "geofence.readOnly": "Bölgeleri İSG sorumlusu, filo yöneticisi ve firma yöneticisi düzenler.",
  "geofence.saved": "{name} kaydedildi.",
  "geofence.deleted": "{name} silindi.",
  "geofence.limitReached": "Bir sahada en fazla {max} bölge olabilir.",
  "geofence.kind.forbidden": "Yasak bölge",
  "geofence.kind.work_area": "Çalışma alanı",
  "geofence.kind.dwell": "Süre sınırı",
  "geofence.kindHint.forbidden": "Araç bu bölgeye girerse alarm oluşur. Yaya yolları ve dar geçitler için.",
  "geofence.kindHint.work_area": "Araç bu alanın dışına çıkarsa alarm oluşur.",
  "geofence.kindHint.dwell": "Araç bölgede belirlediğiniz dakikadan uzun kalırsa alarm oluşur.",
  "geofence.rule.forbidden": "Araç girerse alarm",
  "geofence.rule.work_area": "Araç dışına çıkarsa alarm",
  "geofence.rule.dwell": "Araç {duration} süreden uzun kalırsa alarm",
  "geofence.minutes": "{m} dk",
  "geofence.hours": "{h} sa",
  "geofence.hoursMinutes": "{h} sa {m} dk",
  "geofence.shapePolygonSummary": "Çokgen · {count} köşe",
  "geofence.shapeCircleSummary": "Daire · {radius} m",
  "geofence.allVehicleTypes": "Tüm araçlar",
  "geofence.addTitle": "Yeni bölge",
  "geofence.editTitle": "Bölgeyi düzenle",
  "geofence.dialogHint": "Saha: {site}",
  "geofence.dwellMinutes": "Süre sınırı (dakika)",
  "geofence.dwellHint": "{min}–{max} dakika. Araç bölgede {minutes} dakikadan uzun kalırsa alarm oluşur; her girişte bir kez.",
  "geofence.shape.polygon": "Çokgen",
  "geofence.shape.circle": "Daire",
  "geofence.drawPolygonHint": "Köşe eklemek için haritaya tıklayın; köşeleri sürükleyerek taşıyın. Klavyeyle: haritayı ok tuşlarıyla kaydırıp \"Harita ortasına köşe ekle\"ye basın; seçili köşe ok tuşlarıyla 1 m (Shift ile 5 m) kayar, Delete ile silinir.",
  "geofence.drawCircleHint": "Merkezi seçmek için haritaya tıklayın veya merkezi sürükleyin, ardından yarıçapı girin.",
  "geofence.mapError": "Harita yüklenemedi. Bağlantınızı kontrol edip yeniden deneyin.",
  "geofence.mapLabel": "Bölge çizim haritası",
  "geofence.vertexLabel": "Köşe {n}",
  "geofence.centerLabel": "Dairenin merkezi",
  "geofence.vertexCount": "{count} köşe",
  "geofence.addVertexAtCenter": "Harita ortasına köşe ekle",
  "geofence.undoVertex": "Son köşeyi geri al",
  "geofence.clearVertices": "Temizle",
  "geofence.centerSet": "Merkez seçildi",
  "geofence.centerMissing": "Merkez seçilmedi",
  "geofence.centerAtMapCenter": "Merkezi harita ortasına koy",
  "geofence.radius": "Yarıçap (m)",
  "geofence.radiusHint": "{min}–{max} metre.",
  "geofence.vehicleTypesHint": "Hiçbirini seçmezseniz bölge tüm araçlar için geçerlidir.",
  "geofence.activeLabel": "Etkin",
  "geofence.activeHint": "Pasif bölge alarm üretmez; silinmeden saklanır.",
  "geofence.gnssNote": "Bölgeler yalnızca açık alandaki uydu (GNSS) konumuyla değerlendirilir; kapalı alanda alarm oluşmaz. Sınırda titremeyi önlemek için araç sınırı en az 3 m geçip en az 5 sn ve art arda 5 konum boyunca orada kalınca durum değişir; bu yüzden bölgeler en az 10 m genişliğinde olmalıdır. Süre sınırı alarmı, araçtan son 5 dakika içinde bölgeden konum geldiyse oluşur. Alarm yalnızca bildirimdir, araç durdurulmaz.",
  "geofence.deleteTitle": "Bölge silinsin mi?",
  "geofence.deleteBody": "{name} silinecek. Bu bölge için daha önce oluşan alarmlar kalır, ancak bölgenin şekli artık gösterilmez.",
  "geofence.issue.name_required": "Bölgeye bir ad verin.",
  "geofence.issue.name_too_long": "Ad en fazla 80 karakter olabilir.",
  "geofence.issue.invalid_kind": "Bir tür seçin.",
  "geofence.issue.invalid_shape": "Çokgen veya daire seçin.",
  "geofence.issue.invalid_coordinate": "Bölgenin konumu eksik veya geçersiz. Haritada yeniden çizin.",
  "geofence.issue.too_few_vertices": "Çokgen için haritada en az 3 köşe işaretleyin.",
  "geofence.issue.too_many_vertices": "Bir çokgen en fazla 200 köşeli olabilir.",
  "geofence.issue.self_intersecting": "Çokgenin kenarları birbirini kesiyor. Köşeleri taşıyarak düzeltin.",
  "geofence.issue.too_narrow": "Bölge en az 10 m genişliğinde olmalı. GPS sahada 2–5 m sapabildiği için daha dar alanlar (ör. yaya yolları) güvenilir izlenemez; bu tür alanlar için UWB veya kamera tabanlı çözümler önerilir.",
  "geofence.issue.radius_out_of_range": "Yarıçap en fazla 5000 metre olabilir.",
  "geofence.issue.dwell_out_of_range": "Süre 1 ile 1440 dakika arasında tam sayı olmalı.",
  "geofence.issue.dwell_only_for_dwell": "Süre yalnızca süre sınırı bölgelerinde kullanılır.",
  "geofence.issue.invalid_vehicle_type": "Bilinmeyen araç tipi seçildi.",
  "alarmZone.title": "Bölge",
  "alarmZone.zone": "Bölge",
  "alarmZone.deleted": "Bölge silinmiş",
  "alarmZone.unavailable": "Bölge görüntülenemiyor",
  "alarmZone.kind": "Kural",
  "alarmZone.point": "İhlal noktası",
  "alarmZone.noPoint": "Konum yok (alarm, araç bölgede kalırken dakikalık kontrolle oluştu)",

  "alarmZone.mapLabel": "Bölge ve ihlal noktası haritası",
  "alarmZone.pointPin": "İhlal noktası",
  "alarmZone.noBlock": "Araç durdurulmaz; bölge alarmı yalnızca bildirimdir.",
  "map.zones.toggle": "Bölgeleri göster",
  "map.zones.legend": "Bölge türleri",
  "error.invalid_geofence": "Bölge kaydedilemedi: şekil, ad veya süre kurallara uymuyor.",
  "error.too_many_geofences": "Bu sahada bölge sınırına (50) ulaşıldı.",

  /* Sprint 7a: pre-shift checklist (ADR 0016) */
  "error.checklist_token_invalid": "Bu QR kod geçersiz veya yenilenmiş.",
  "error.invalid_checklist": "Kontrol listesi eksik veya hatalı.",
  "error.invalid_photo": "Fotoğraf kabul edilmedi: JPEG, PNG veya WebP ve en fazla 5 MB olmalı.",
  "error.invalid_template": "Şablon kaydedilemedi: ad, madde kodu veya metin kurallara uymuyor.",
  "error.invalid_shift": "Vardiya kaydedilemedi: ad, saatler veya günler geçersiz.",
  "error.too_many_shifts": "Bu sahada vardiya sınırına (10) ulaşıldı.",
  "error.invalid_recipient": "Alıcı eklenemedi: kişi bu sahayı göremiyor, adres geçersiz veya zaten listede.",
  "error.fault_resolved": "Bu arıza zaten giderildi olarak işaretlenmiş.",
  "alarm.type.checklist_critical": "Kontrol listesi: kritik arıza",
  "alarm.type.checklist_missed": "Kontrol listesi doldurulmadı",
  "alarm.type.checklist_notes": "Kontrol listesi: arıza bildirimi",
  "alarmKind.maintenance_report": "Bakım raporu (dış adres)",
  "alarmNotify.external": "Dış adres",
  "alarmChecklist.title": "Kontrol listesi",
  "alarmChecklist.shift": "Vardiya",
  "alarmChecklist.open": "Aracın kontrol listelerini aç",
  "alarmChecklist.missedText": "Araç bu vardiyada kontrol listesi doldurulmadan kullanıldı.",
  "alarmChecklist.noLock": "Araç kilitlenmez; bu yalnızca bildirimdir.",
  "nav.group.checklist": "Kontrol listesi",
  "nav.checklistFaults": "Arızalar",
  "nav.checklistTemplates": "Şablonlar",
  "checklist.category.counterbalance_electric": "Akülü forklift",
  "checklist.category.counterbalance_ic": "Dizel/LPG forklift",
  "checklist.category.reach_truck": "Reach truck",
  "checklist.category.order_picker": "Sipariş toplama aracı",
  "checklist.category.pallet_truck": "Akülü transpalet",
  "checklist.systemName": "{category} (standart)",
  "checklist.result.ok": "Uygun",
  "checklist.result.ok_with_notes": "Uygun, bildirim var",
  "checklist.result.maintenance_required": "Bakım gerekli",
  "checklist.answer.ok": "Uygun",
  "checklist.answer.not_ok": "Uygun değil",
  "checklist.answer.na": "Yok",
  "checklist.critical": "Kritik",
  "checklist.photoRequired": "Fotoğraf",
  "cf.title": "Vardiya öncesi kontrol",
  "cf.invalid": "Bu QR kod geçersiz veya yenilenmiş. Lütfen yöneticinize haber verin.",
  "cf.rateLimited": "Çok fazla deneme yapıldı. Birkaç dakika sonra tekrar deneyin.",
  "cf.loadError": "Form yüklenemedi. Bağlantınızı kontrol edip tekrar deneyin.",
  "cf.shift": "Vardiya: {name}",
  "cf.noShift": "Tanımlı vardiya dışında",
  "cf.alreadySubmitted": "Bu vardiya için kontrol listesi zaten doldurulmuş. Gerekirse yeniden doldurabilirsiniz.",
  "cf.openFaults": "Açık arızalar (önceki kontrollerden)",
  "cf.intro": "Her maddeyi kontrol edin ve işaretleyin. Araçta olmayan donanım için \"Yok\" seçin.",
  "cf.note": "Not",
  "cf.notePlaceholder": "Ne gördüğünüzü kısaca yazın",
  "cf.addPhoto": "Fotoğraf ekle",
  "cf.photoUploading": "Fotoğraf yükleniyor…",
  "cf.photoRemove": "Fotoğrafı kaldır",
  "cf.photoAlt": "{code} maddesinin fotoğrafı {n}",
  "cf.photoCount": "{n}/3 fotoğraf",
  "cf.progress": "{done}/{total} madde",
  "cf.submit": "Gönder",
  "cf.submitting": "Gönderiliyor…",
  "cf.missing": "{n} madde eksik. İşaretli maddeleri tamamlayın.",
  "cf.done": "Teşekkürler, kontrol listesi kaydedildi.",
  "cf.doneDetail": "{fleetNo} · {time}",
  "cf.again": "Yeni kontrol listesi doldur",
  "cf.waitPhotos": "Fotoğraflar yükleniyor; bitince tekrar \"Gönder\"e dokunun.",
  "error.form_changed": "Form güncellendi, yeniden yükleyin.",
  "error.invalid_dvr_settings": "Geçersiz kayıt cihazı ayarı. Kanal 1–16 arasında olmalıdır.",
  "cf.formChanged": "Form güncellendi, yeniden yükleyin. Değişmeyen maddelerdeki yanıtlarınız korunur.",
  "cf.reload": "Formu yeniden yükle",
  "cf.naNotAllowed": "Bu maddede \"Yok\" seçilemez",
  "cf.issue.na_not_allowed": "Bu madde için \"Yok\" seçilemez; \"Uygun\" veya \"Uygun değil\" seçin.",
  "templateEdit.allowNa": "Kritik olsa da \"Yok\" yanıtına izin ver (koşullu donanım)",
  "checklist.allowNa": "\"Yok\" seçilebilir",
  "cf.language": "Dil",
  "cf.issue.missing_answer": "Bir seçenek işaretleyin.",
  "cf.issue.duplicate_answer": "Bu madde birden fazla yanıtlandı.",
  "cf.issue.unknown_item": "Bu madde artık şablonda yok. Formu yenileyin.",
  "cf.issue.invalid_answer": "Geçersiz yanıt.",
  "cf.issue.note_required": "\"Uygun değil\" için not yazın.",
  "cf.issue.note_too_long": "Not en fazla 500 karakter olabilir.",
  "cf.issue.photo_required": "Bu madde için fotoğraf ekleyin.",
  "cf.issue.too_many_photos": "En fazla 3 fotoğraf eklenebilir.",
  "vehicleDetail.tab.checklist": "Kontrol listesi",
  "vehicleChecklist.maintenance": "Bakım gerekli",
  "vehicleChecklist.maintenanceHint": "Açık kritik arıza var. Araç kilitlenmez; arıza giderilince işaretleyin.",
  "vehicleChecklist.openFaults": "Açık arızalar",
  "vehicleChecklist.noOpenFaults": "Açık arıza yok.",
  "vehicleChecklist.history": "Kontrol listesi geçmişi",
  "vehicleChecklist.empty": "Bu araç için henüz kontrol listesi doldurulmadı.",
  "vehicleChecklist.when": "Zaman",
  "vehicleChecklist.shift": "Vardiya",
  "vehicleChecklist.operator": "Operatör",
  "vehicleChecklist.operatorUnknown": "Belirlenemedi (kart oturumu yok)",
  "vehicleChecklist.result": "Sonuç",
  "vehicleChecklist.template": "Şablon",
  "vehicleChecklist.details": "Ayrıntılar",
  "vehicleChecklist.hideDetails": "Ayrıntıları gizle",
  "vehicleChecklist.impact": "Önceki kontrolden sonra darbe alarmı vardı",
  "vehicleChecklist.loadError": "Kontrol listeleri yüklenemedi.",
  "vehicleChecklist.photos": "Fotoğraflar",
  "checklistQr.title": "QR etiketi",
  "checklistQr.hint": "Etiketi aracın operatörün göreceği bir yerine yapıştırın. QR kod, formu konsola giriş yapmadan açar.",
  "checklistQr.print": "Etiketi yazdır",
  "checklistQr.printAll": "Etiket sayfası yazdır",
  "checklistQr.rotate": "QR kodunu yenile",
  "checklistQr.rotateTitle": "QR kodu yenilensin mi?",
  "checklistQr.rotateText": "Eski etiket hemen çalışmaz hâle gelir. Yeni etiketi yazdırıp eskisinin yerine yapıştırın.",
  "checklistQr.noAccess": "QR kodunu filo yöneticisi ve üzeri görebilir.",
  "checklistQr.labelTitle": "Vardiya öncesi kontrol",
  "checklistQr.labelText": "Vardiya başında bu kodu telefonunuzla okutun ve formu doldurun (yaklaşık 3 dakika).",
  "checklistQr.labelSample": "Örnek etiket metni — sahaya göre uyarlayın.",
  "checklistQr.link": "Form bağlantısı",
  "checklistQr.copy": "Bağlantıyı kopyala",
  "checklistQr.sheetTitle": "QR etiketleri · {site}",
  "checklistQr.close": "Kapat",
  "faults.title": "Arızalar",
  "faults.subtitle": "Kontrol listelerinde \"Uygun değil\" işaretlenen maddeler",
  "faults.filter.open": "Açık",
  "faults.filter.resolved": "Giderildi",
  "faults.filter.all": "Tümü",
  "faults.filterLabel": "Duruma göre süz",
  "faults.vehicle": "Araç",
  "faults.item": "Madde",
  "faults.note": "Not",
  "faults.reported": "Bildirildi",
  "faults.status": "Durum",
  "faults.status.open": "Açık",
  "faults.status.resolved": "Giderildi",
  "faults.resolve": "Giderildi",
  "faults.resolveTitle": "Arıza giderildi mi?",
  "faults.resolveNote": "Yapılan işlem",
  "faults.resolveHint": "Örn. lastik değiştirildi. En fazla 500 karakter.",
  "faults.resolvedBy": "{name} · {time}",
  "faults.empty": "Bu süzgeçle arıza yok.",
  "faults.needsRole": "Arızaları filo yöneticisi ve üzeri kapatır.",
  "faults.photos": "{n} fotoğraf",
  "templates.title": "Kontrol listesi şablonları",
  "templates.subtitle": "Standart şablonu kopyalayıp kendi maddelerinizi ekleyebilir ve araç tiplerine atayabilirsiniz.",
  "templates.system": "Standart",
  "templates.own": "Firma şablonu",
  "templates.items": "{n} madde",
  "templates.copy": "Kopyala",
  "templates.copyName": "{name} (kopya)",
  "templates.view": "Görüntüle",
  "templates.delete": "Sil",
  "templates.deleteTitle": "Şablon silinsin mi?",
  "templates.deleteText": "Atandığı araç tipleri standart şablona döner. Doldurulmuş kontrol listeleri değişmez.",
  "templates.assignTitle": "Araç tiplerine atama",
  "templates.assignHint": "Her araç tipi, burada seçilen şablonla kontrol edilir. Seçim yoksa standart şablon kullanılır.",
  "templates.category": "Araç tipi",
  "templates.template": "Şablon",
  "templates.useSystem": "Standart şablon",
  "templates.viewOnly": "Şablonları saha kısıtı olmayan filo yöneticisi ve firma yöneticisi düzenler.",
  "templates.critical": "{n} kritik",
  "templateEdit.title": "Şablonu düzenle",
  "templateEdit.viewTitle": "Şablon maddeleri",
  "templateEdit.name": "Şablon adı",
  "templateEdit.code": "Kod",
  "templateEdit.textTr": "Madde (Türkçe)",
  "templateEdit.textEn": "Madde (İngilizce)",
  "templateEdit.critical": "Kritik (uygun değilse hemen bildirim)",
  "templateEdit.photo": "Uygun değilse fotoğraf zorunlu",
  "templateEdit.impactFirst": "Darbeden sonra ilk sırada göster",
  "templateEdit.lpgOnly": "Yalnız LPG'li araçlarda",
  "templateEdit.moveUp": "Yukarı taşı",
  "templateEdit.moveDown": "Aşağı taşı",
  "templateEdit.remove": "Maddeyi kaldır",
  "templateEdit.add": "Madde ekle",
  "templateEdit.itemLabel": "Madde {n}",
  "templateEdit.noLock": "Kritik maddeler aracı kilitlemez; yalnızca seçilen kişilere hemen bildirim gider.",
  "templateEdit.issue.name_required": "Şablon adı girin.",
  "templateEdit.issue.name_too_long": "Şablon adı en fazla 80 karakter olabilir.",
  "templateEdit.issue.no_items": "En az bir madde ekleyin.",
  "templateEdit.issue.too_many_items": "Bir şablonda en fazla 60 madde olabilir.",
  "templateEdit.issue.text_required": "Madde metnini (Türkçe) girin.",
  "templateEdit.issue.text_too_long": "Madde metni en fazla 200 karakter olabilir.",
  "templateEdit.issue.invalid_code": "Kod 1–8 karakter: büyük harf, rakam veya tire.",
  "templateEdit.issue.duplicate_code": "Bu kod başka bir maddede kullanılıyor.",
  "siteChecklist.title": "Vardiya öncesi kontrol listesi",
  "siteChecklist.shiftsTitle": "Vardiyalar",
  "siteChecklist.shiftsHint": "Kontrol listesi her vardiya başında zorunludur. Vardiyada kullanılan ama kontrol listesi doldurulmayan araç için 15 dakika sonra alarm oluşur.",
  "siteChecklist.inherited": "Üst sahadan devralındı: {site}",
  "siteChecklist.inheritedHidden": "Üst sahadan devralındı",
  "siteChecklist.noShifts": "Vardiya tanımlı değil: \"kontrol listesi doldurulmadı\" alarmı oluşmaz.",
  "siteChecklist.addShift": "Vardiya ekle",
  "siteChecklist.editShift": "Vardiyayı düzenle",
  "siteChecklist.shiftName": "Vardiya adı",
  "siteChecklist.start": "Başlangıç",
  "siteChecklist.end": "Bitiş",
  "siteChecklist.days": "Günler (başlangıç günü)",
  "siteChecklist.timeZone": "Saat dilimi",
  "siteChecklist.overnight": "ertesi gün {time}",
  "siteChecklist.deleteShift": "Vardiyayı sil",
  "siteChecklist.deleteShiftText": "\"{name}\" vardiyası silinsin mi? Geçmiş kontrol listeleri değişmez.",
  "siteChecklist.recipientsTitle": "Kontrol listesi bildirimleri",
  "siteChecklist.recipientsHint": "Kritik arıza ve doldurulmayan kontrol listesi bu kişilere hemen gider; kritik olmayan arızalar günlük özete girer. Operatöre uyarı gösterilmez, araç kilitlenmez.",
  "siteChecklist.noRecipients": "Alıcı tanımlı değil: bildirimler sahanın İSG sorumlusu ve filo yöneticisine gider.",
  "siteChecklist.addMember": "Konsol kullanıcısı ekle",
  "siteChecklist.addExternal": "Dış e-posta ekle",
  "siteChecklist.member": "Kullanıcı",
  "siteChecklist.email": "E-posta adresi",
  "siteChecklist.label": "Açıklama",
  "siteChecklist.labelHint": "Örn. dış bakım firmasının adı.",
  "siteChecklist.externalHint": "Dış adreslere araç, arızalı maddeler, notlar ve 7 gün geçerli fotoğraf bağlantıları gider; operatör adı gönderilmez (KVKK).",
  "siteChecklist.external": "Dış adres",
  "siteChecklist.remove": "Kaldır",
  "siteChecklist.removeTitle": "Alıcı kaldırılsın mı?",
  "siteChecklist.removeText": "{name} artık bu sahanın kontrol listesi bildirimlerini almaz.",
  "siteChecklist.externalAdminOnly": "Dış e-posta adreslerini yalnızca firma yöneticisi ekler veya siler.",
  "siteChecklist.loadError": "Kontrol listesi ayarları yüklenemedi.",
  "siteChecklist.ownList": "Bu sahanın listesi",
  "siteChecklist.applies": "Şu anda geçerli alıcılar",

  // UI phase B (ADR 0029): toasts, empty states, dates, help, alarm flow, navigation.
  "toast.roleChanged": "{name} kullanıcısının yeni rolü: {role}.",
  "toast.inviteCreated": "{email} için davet oluşturuldu.",
  "toast.alarmCopyOn": "Yöneticiler artık her alarm e-postasının kopyasını alacak.",
  "toast.alarmCopyOff": "Yöneticiler artık alarm e-postalarının kopyasını almayacak.",
  "toast.memberRemoved": "{name} firmadan çıkarıldı.",
  "toast.inviteRevoked": "{email} daveti iptal edildi.",
  "invitations.emptyHint": "Yeni kullanıcıları e-posta ile davet edin; davet bağlantısı 7 gün geçerlidir.",
  "toast.savedNamed": "{name} kaydedildi.",
  "toast.addedNamed": "{name} eklendi.",
  "toast.createdNamed": "{name} oluşturuldu.",
  "toast.deletedNamed": "{name} silindi.",
  "sites.emptyHint": "Önce ana sahayı ekleyin; depo, bölüm ve bölgeleri altına birim olarak tanımlayın.",
  "vehicles.none": "Henüz araç eklenmemiş",
  "vehicles.noneHintManager": "Araçları ekleyip bir sahaya bağlayın; ardından telematik cihazı eşleyin.",
  "vehicles.noneHintNoSite": "Araç eklemeden önce bir saha tanımlanmalı.",
  "vehicles.noneHintViewer": "Araçlar filo yöneticisi tarafından eklenir.",
  "toast.templateCopied": "Şablon kopyalandı; şimdi düzenleyebilirsiniz.",
  "toast.copyFailed": "Kopyalanamadı.",
  "toast.saveFailed": "Kaydedilemedi.",
  "toast.assignmentSaved": "Şablon ataması kaydedildi.",
  "toast.templateSaved": "Şablon kaydedildi.",
  "toast.templateDeleted": "Şablon silindi.",
  "toast.shiftSaved": "\"{name}\" vardiyası kaydedildi.",
  "toast.shiftDeleted": "\"{name}\" vardiyası silindi.",
  "toast.recipientAdded": "Alıcı eklendi.",
  "toast.recipientRemoved": "{name} alıcılardan çıkarıldı.",
  "toast.operatorLeft": "{name} için ayrılış tarihi kaydedildi.",
  "toast.cardAdded": "{name} için kart eklendi.",
  "toast.cardLost": "{uid} kartı kayıp olarak işaretlendi.",
  "toast.cardRevoked": "{uid} kartı iptal edildi.",
  "toast.documentSaved": "Belge kaydedildi.",
  "toast.documentDeleted": "Belge silindi.",
  "toast.permissionAdded": "Yetki verildi.",
  "toast.permissionRemoved": "Yetki kaldırıldı.",
  "card.noneHint": "Kart tanımlanınca operatör, yetkili olduğu araçları bu kartla çalıştırabilir.",
  "doc.noneHint": "Operatör belgesi, sürücü belgesi veya eğitim sertifikasını bitiş tarihiyle kaydedin; süresi yaklaşınca konsol uyarır.",
  "perm.noneHint": "Yetki verilmeyen operatörün kartı hiçbir aracın kart listesine girmez.",
  "vehicleOps.noneHint": "Bir operatörün bu aracı kullanabilmesi için sahaya, araç tipine veya bu araca yetkisi olmalıdır.",
  "vehicleOps.grant": "Yetki ver",
  "toast.devicePaired": "{device} cihazı {vehicle} aracına bağlandı.",
  "toast.deviceUnpaired": "{device} cihazı araçtan ayrıldı.",
  "toast.dvrSaved": "Kayıt cihazı ayarları kaydedildi.",
  "help.about": "Yardım: {topic}",
  "help.deviceHealth": "Kayıt cihazının kayıt ortamı ve kameralarının son bildirilen durumu. \"Sorun yok\": beklenen kayıt ortamı ve takılı kameralar düzgün çalışıyor. \"N sorun\": en az biri kayıt yapmıyor, takılı değil veya hata veriyor; sorun {raise} dakika sürerse alarm oluşur, {clear} dakika düzgün bildirilince kapanır. {stale} dakikadır bildirilmeyen sorun \"güncel değil\" olarak işaretlenir. \"—\": cihaz kayıt cihazı durumu bildirmiyor veya beklenen ayar yok.",
  "push.removed": "{name} bildirim listesinden kaldırıldı.",
  "toast.hoursSaved": "{site} için mesai saatleri kaydedildi.",
  "toast.hoursResetParent": "{site} artık üst sahanın mesai saatlerini kullanıyor.",
  "toast.hoursResetDefault": "{site} artık varsayılan mesai saatlerini kullanıyor.",
  "toast.nightSaved": "{site} için gece sorumluları kaydedildi.",
  "toast.nightReset": "{site} için sahaya özel gece listesi kaldırıldı.",
  "toast.deviceBlocked": "{device} engellendi.",
  "toast.deviceUnblocked": "{device} cihazının engeli kaldırıldı.",
  "geofence.emptyHint": "Yaya yolları gibi yasak bölgeleri veya çalışma alanlarını haritada çizerek ekleyin.",
  "toast.faultResolved": "{item} arızası giderildi olarak işaretlendi.",
  "toast.qrRotated": "Yeni QR kod oluşturuldu. Yeni etiketi yazdırıp eskisinin yerine yapıştırın.",
  "vehicleChecklist.emptyHint": "Operatör, araçtaki QR etiketi telefonla okutup listeyi doldurduğunda kayıt burada görünür.",
  "toast.moduleSettingsSaved": "Modül ayarları kaydedildi; bir dakika içinde cihaza gönderilir.",
  "date.invalid": "Tarihi {pattern} biçiminde yazın.",
  "date.required": "Bir tarih girin.",
  "date.tooEarly": "En erken {min} olabilir.",
  "date.tooLate": "En geç {max} olabilir.",
  "date.format": "Biçim: {pattern}",
  "date.openPicker": "Takvimi aç",
  "toast.alarmAcknowledged": "{alarm} onaylandı.",
  "toast.alarmAlreadyAcked": "{alarm} başka biri tarafından zaten onaylanmış.",
  "toast.alarmAckFailed": "{alarm} onaylanamadı; alarm açık kaldı.",
  "alarmQuick.title": "Alarmı onayla",
  "alarmQuick.button": "Onayla",
  "alarmQuick.rowButton": "Onayla: {type}, {time}",
  "alarmQuick.openDetail": "Ayrıntıları aç",
  "alarmQuick.shortcut": "Ctrl + Enter ile de onaylayabilirsiniz.",
  "help.kpi.utilisation": "Kullanım esası penceresi içinde kontağın açık kaldığı sürenin, pencerenin süresine oranı. Pencere, sahada vardiya varsa vardiya saatleri, yoksa sahanın mesai saatleridir (ayar yoksa Pzt–Cum 08:00–18:00). Cihazı olmayan araçlar hesaba girmez.",
  "help.kpi.impacts": "Dönem içindeki darbe alarmlarının sayısı. Alttaki oran, darbe sayısının 100 kontak açık saate göre karşılığıdır (darbe × 100 ÷ kontak açık saat).",
  "help.kpi.checklist": "Aracın kullanıldığı (kontak açık veya hareket eden) vardiyalardan kontrol listesi doldurulanların oranı. Vardiya başlangıcından 30 dakika önce doldurulan liste de sayılır.",
  "help.kpi.geofence": "Yasak bölgeye giriş, çalışma alanından çıkış ve bölgede izin verilen süreyi aşma alarmlarının toplamı.",
  "help.kpi.battery": "Büyük sayı: şarjı %{low} altında olan araç sayısı (akü kartındaki sarı seviye). Derin deşarj: cihazın dönem içinde bildirdiği derin deşarj olayları. Ortalama şarj: dönemdeki ortalama şarj yüzdesi.",
  "help.fleetStates.topic": "Araç durumları",
  "help.fleetStates": "Çalışıyor: kontak açık ve hız en az {kmh} km/sa. Rölanti: kontak açık, araç duruyor. Kontak kapalı: cihaz bağlı, kontak kapalı. Çevrim dışı: cihazdan {offline} dakikadır mesaj gelmedi.",
  "help.usage.topic": "Sütunlar",
  "help.usage": "Kontak açık: kontağın açık olduğu süre. Hareket: kontak açık ve hız en az {kmh} km/sa. Rölanti: kontak açık ama araç hareket etmiyor. Kullanım %: esas penceresi (vardiya, mesai veya günün 24 saati) içindeki kontak süresinin pencere süresine oranı. Bir kaydın durumu bir sonraki kayda kadar, en fazla {cap} dakika sürer.",
  "help.spaghetti.topic": "Hangi noktalar çizilir?",
  "help.spaghetti": "Kontak açık ve hızı en az {kmh} km/sa olan, cihaz saati doğrulanmış GNSS konumları çizilir; cihaz konum doğruluğu bildiriyorsa en fazla {acc} m olmalıdır. Sunucu her aracın her {bucket} saniyesinden bir nokta alır. {gap} saniyeden uzun aralar ve {jump} km/sa üstü sıçramalar çizgiyi böler.",
  "help.driving.topic": "Hız bantları",
  "help.driving": "Her bant, hareket süresinin o hız aralığında geçen payıdır ({bands} km/sa). Hareket: kontak açık ve hız en az {kmh} km/sa. {max} km/sa üstü hız değerleri sensör veya GNSS sıçraması sayılır.",
  "help.heatmap.topic": "Isı haritası nasıl okunur?",
  "help.heatmap": "Renk maviden kırmızıya doğru yoğunluğun arttığını gösterir. Olaylar modunda her hücre o alandaki olayları sayar; darbeler seviyelerine (1–3) göre ağırlık alır. Kullanım modunda hareketli araç konumları sayılır. Hücreler yaklaşık {size} m boyundadır.",
  "nav.holdsCurrent": "açık sayfa bu grupta",
  "quick.open": "Hızlı geçiş (Ctrl + K)",
  "quick.title": "Hızlı geçiş",
  "quick.description": "Ekran, saha, araç veya cihaz adını yazın.",
  "quick.label": "Aranacak ad",
  "quick.placeholder": "Ör. FL-01, Raporlar, FTS-000123",
  "quick.results": "Sonuçlar",
  "quick.none": "\"{query}\" için sonuç yok.",
  "quick.hint": "↑ ↓ ile seçin, Enter ile açın, Esc ile kapatın.",
  "quick.deviceOn": "{vehicle} aracında",
  "quick.kind.screen": "Ekran",
  "quick.kind.site": "Saha",
  "quick.kind.vehicle": "Araç",
  "quick.kind.device": "Cihaz",
  "quick.kind.vehicleList": "Liste",
  "quick.allVehicles": "Tüm eşleşen araçları listede göster",
  "quick.allVehiclesDetail": "Araç listesinde ara: \"{query}\"",
  "bottomNav.label": "Sık kullanılan ekranlar",
  "bottomNav.overview": "Genel bakış",
  "bottomNav.map": "Harita",
  "bottomNav.alarms": "Alarmlar",
  "bottomNav.vehicles": "Araçlar",
  "bottomNav.faults": "Arızalar",
  "bottomNav.permissions": "Yetkiler",
  "bottomNav.menu": "Menü",
  "bottomNav.alarmsOpen": ", {count} açık alarm",
  "map.sheet.toggle": "Araç listesi · {count}",
  "map.sheet.alarms": "Alarm: {count}",
  "reports.filter.toggle": "Filtreler",

  // ADR 0034: Teltonika console, battery, lift and eco-driving.
  "nav.reportBattery": "Akü ve şarj",
  "nav.reportLift": "Direk (asansör)",
  "error.invalid_imei": "IMEI geçersiz. 15 haneli olmalı ve son hane kontrol hanesiyle (Luhn) uyuşmalı.",
  "error.invalid_calibration": "Kalibrasyon değerleri geçersiz. Kanalları, eşikleri ve sınırları kontrol edin.",
  "alarm.type.battery_low": "Akü gerilimi düşük",
  "device.family": "Cihaz türü",
  "deviceFamily.fts": "FTS ünitesi",
  "deviceFamily.mdvr": "Kayıt cihazı (m-DVR)",
  "deviceFamily.teltonikaModel": "Teltonika ({model})",
  "register.kind": "Cihaz türü",
  "register.kind.fts": "FTS ünitesi",
  "register.kind.teltonika": "Teltonika (FMC130)",
  "register.teltonikaNote": "Teltonika ünitesi IMEI'si ile tanınır ve TLT-<IMEI> kimliğiyle kaydedilir. Ünite MQTT kullanmaz; oluşturulan gizli anahtar bu ünitede kullanılmaz, yalnızca etiket kodu müşterinin cihazı sahiplenmesi içindir. IMEI ayrıca ağ geçidinin izin listesine eklenmelidir.",
  "register.imeiLines": "IMEI listesi",
  "register.imeiLinesHint": "Her satıra bir IMEI (15 hane). İsterseniz virgülden sonra SIM kartın ICCID'si.",
  "register.lineImeiFormat": "IMEI tam 15 rakam olmalı",
  "register.lineImeiChecksum": "IMEI kontrol hanesi tutmuyor (yazım hatası olabilir)",
  "register.lineIccid": "ICCID 18–22 rakam olmalı",
  "teltonika.immo.label": "İmmobilizer",
  "teltonika.immo.no_card": "Kart okutulmadı",
  "teltonika.immo.card": "Kart okutuldu",
  "teltonika.immo.authorized": "Yetkili kart, çalıştırma serbest",
  "teltonika.immo.unknown": "Bilinmiyor (ünite henüz bildirmedi)",
  "teltonika.immo.note": "Yalnızca kartsız ilk çalıştırmayı engellemek için ayarlanır; röle marş devresine bağlanmalı, çalışan aracı durdurmamalıdır (montaj kontrol listesine bakın). FTS'den immobilizere veya çıkışa komut gönderilemez.",
  "teltonika.sync.title": "Kart listesi eşitleme (Teltonika)",
  "teltonika.sync.loadError": "Eşitleme durumu yüklenemedi.",
  "teltonika.sync.state": "Durum",
  "teltonika.sync.noReader": "Kart okuyucu yok",
  "teltonika.sync.inSync": "Cihazdaki liste güncel",
  "teltonika.sync.pending": "Gönderilmeyi bekleyen değişiklik var",
  "teltonika.sync.version": "Liste sürümü",
  "teltonika.sync.versionValue": "güncel {ver} · cihazda onaylı {acked}",
  "teltonika.sync.cards": "Yetkili kart sayısı",
  "teltonika.sync.lastSync": "Son başarılı eşitleme",
  "teltonika.sync.changes": "Bekleyen değişiklikler",
  "teltonika.sync.changesValue": "{add} eklenecek · {remove} silinecek · {unknown} yuva yeniden yazılacak",
  "teltonika.sync.noChanges": "Yok",
  "teltonika.sync.failures": "Hatalar",
  "teltonika.sync.failureValue": "{count} deneme başarısız, son hata: {error}",
  "teltonika.sync.lastFailure": "Son hata: {error} (sonra düzeldi)",
  "teltonika.sync.noFailures": "Hata yok",
  "teltonika.sync.retryAt": "Yeniden deneme",
  "teltonika.sync.readback": "Günlük geri okuma",
  "teltonika.sync.note": "Sayılar ve zamanlar gösterilir; kart numaraları gösterilmez (KVKK).",
  "teltonika.safety.label": "Güvenlik kontrolü (salt okunur)",
  "teltonika.safety.never": "Henüz yapılmadı",
  "teltonika.safety.ok": "Senaryolarda çıkış kontrolü kapalı",
  "teltonika.safety.unsafe": "Çıkış kontrolü açık: {scenarios}",
  "teltonika.safety.fix": "Cihazdaki bir senaryo çıkışı (DOUT) sürebilecek şekilde ayarlı ve alarm oluşturuldu. FTS bu ayarı değiştirmez: ünite TCT ile bağlanıp ilgili senaryonun çıkış kontrolü 'None' yapılmalıdır.",
  "teltonika.scenario.green_driving": "Eko sürüş",
  "teltonika.scenario.overspeeding": "Hız aşımı",
  "teltonika.scenario.excessive_idling": "Uzun rölanti",
  "teltonika.scenario.jamming": "Sinyal karıştırma",
  "tct.title": "Saha kurulum kontrol listesi (TCT)",
  "tct.progress": "{done}/{total} tamam",
  "tct.intro": "{device} için Teltonika Configurator (TCT) ile cihaz başına bir kez yapılır. İşaretler yalnızca bu ekranda tutulur.",
  "tct.note": "Ayrıntılar: docs/ops/teltonika-gateway.md (saha kurulum kartı). Hiçbir adım darbe sonrası aracı durduracak bir ayar içermez.",
  "tct.server.title": "Sunucu",
  "tct.server.body": "GPRS → Server Settings: alan adı ağ geçidi, port 5027, protokol TCP, TLS açık.",
  "tct.certificate.title": "Sertifika",
  "tct.certificate.body": "Security → Certificates: sunucu sertifikasının kök CA'sını (ISRG Root X1) yükleyin.",
  "tct.protocol.title": "Protokol ve kontak",
  "tct.protocol.body": "System: Codec 8 Extended, kontak kaynağı yalnızca DIN1, saat GNSS + NTP.",
  "tct.acquisition.title": "Kayıt aralıkları",
  "tct.acquisition.body": "Hareket hâlinde 1 sn ölçüm, 3 sn gönderim; dururken 300 sn (en fazla 540 sn).",
  "tct.io.title": "I/O öncelikleri",
  "tct.io.body": "239, 240, 21, 66, 78, 182 ve 248 Low (her kayıtta). Eko sürüş (253/254) olay olarak açık kalabilir.",
  "tct.analog.title": "Analog girişler",
  "tct.analog.body": "AIN1 (9) / AIN2 (6) Low, yalnızca bağlıysa (akü bölücüsü, direk sensörü). Anlamı konsolda aracın kalibrasyonunda seçilir.",
  "tct.reader.title": "Kart okuyucu",
  "tct.reader.body": "Features → 1-Wire: iButton / RFID okuyucu açık.",
  "tct.immobilizer.title": "İmmobilizer",
  "tct.immobilizer.body": "Immobilizer senaryosu açık, çıkış DOUT1, iButton List Check açık, liste boş (listeyi FTS yazar). Yalnızca kartsız ilk çalıştırmayı engellemek için; çalışan aracı durdurmamalıdır.",
  "tct.crash.title": "Çarpışma algılama",
  "tct.crash.body": "Crash Detection açık, öncelik High; çıkış kontrolü (DOUT) None. Darbe aracı durduramaz.",
  "tct.scenarios.title": "Diğer senaryolar",
  "tct.scenarios.body": "Eko sürüş, hız aşımı, uzun rölanti, sinyal karıştırma, geofence: çıkış kontrolü None. FTS günde bir okur, açıksa alarm verir.",
  "tct.commands.title": "GPRS komutları",
  "tct.commands.body": "Açık (Codec 12). FTS yalnızca kart yuvası yazar ve salt okunur sorgular gönderir.",
  "tct.register.title": "Kayıt ve izin listesi",
  "tct.register.body": "Cihaz TLT-<IMEI> ile kayıtlı ve araca eşli; IMEI ağ geçidinin izin listesinde.",
  "tct.cards.title": "Kartlar",
  "tct.cards.body": "Operatör kartları konsolda cihazın okuduğu 16 onaltılık haneyle kayıtlı.",
  "tct.verify.title": "İlk bağlantı",
  "tct.verify.body": "Konsolda konum, kontak ve gerilim görünüyor; kart listesi onaylandı; güvenlik kontrolü 'kapalı' diyor.",
  "calib.title": "Analog girişler ve kalibrasyon",
  "calib.batterySource": "Akü gerilimi kaynağı",
  "calib.batterySourceHint": "Akü gerilimini hangi giriş ölçüyor? Bilinmiyorsa 'Yok' seçin: akü raporu gerilim göstermez.",
  "calib.source.none": "Yok (akü ölçülmüyor)",
  "calib.source.module": "FTS akü modülü",
  "calib.source.supply": "Ünite doğrudan aküden besleniyor",
  "calib.source.ain1": "Analog giriş 1 (gerilim bölücü)",
  "calib.source.ain2": "Analog giriş 2 (gerilim bölücü)",
  "calib.lift.none": "Yok",
  "calib.lift.ain1": "Analog giriş 1",
  "calib.lift.ain2": "Analog giriş 2",
  "calib.formula": "Hesap",
  "calib.formulaValue": "giriş (V) × {scale} + {offset}",
  "calib.batLowV": "Düşük akü eşiği",
  "calib.alertOff": "Uyarı kapalı",
  "calib.liftSource": "Direk sensörü",
  "calib.liftThresholds": "Direk eşikleri",
  "calib.liftThresholdsValue": "kalkıyor ≥ {on} · indi ≤ {off}",
  "calib.liftDrive": "'Sürüşte direk' hız eşiği",
  "calib.chargeRise": "Şarj artışı (yedek kural)",
  "calib.volts": "{v} V",
  "calib.kmh": "{v} km/sa",
  "calib.supplyNote": "Besleme gerilimi (IO 66) ünitenin DC-DC dönüştürücü çıkışıdır, akü gerilimi değildir. Yalnızca ünite doğrudan aküden besleniyorsa akü kaynağı olarak seçilir.",
  "calib.noSource": "Akü kaynağı yok: akü raporu bu araç için gerilim göstermez.",
  "calib.defaults": "Kalibrasyon girilmedi; varsayılanlar gösteriliyor.",
  "calib.dialogTitle": "{vehicle} · analog girişler",
  "calib.dialogDescription": "Ünitenin analog girişlerinin bu araçta neyi ölçtüğünü ve eşikleri girin. Değişiklik raporlarda geçmişe de uygulanır.",
  "calib.batteryGroup": "Akü",
  "calib.liftGroup": "Direk (asansör)",
  "calib.scale": "Çarpan",
  "calib.scaleHint": "Gerilim bölücü oranı. Örnek: 1:4 bölücüde 4.",
  "calib.offset": "Sabit (ekle)",
  "calib.supplyWarning": "Ünite bir DC-DC dönüştürücüyle besleniyorsa besleme gerilimi aküyü göstermez. Bunu yalnızca ünite doğrudan aküye bağlıysa seçin.",
  "calib.batLowHint": "Boş bırakılırsa düşük akü uyarısı kapalıdır (varsayılan). Yalnızca dinlenme hâlindeki ölçümler değerlendirilir.",
  "calib.batLowHintSuggested": "Boş = uyarı kapalı (varsayılan). {nominal} V akü için öneri: {v} V (kurşun-asit, yaklaşık %20 dolulukta dinlenme gerilimi). Yalnızca dinlenme hâlindeki ölçümler değerlendirilir.",
  "calib.chargeRiseHint": "Yalnızca şarj seviyesi bilinmiyorsa: kontak kapandıktan 10 dakika sonraki tabandan bu kadar artış 5 dakika sürerse şarj sayılır.",
  "calib.liftOn": "Kalkıyor (bu değer ve üstü)",
  "calib.liftOff": "İndi (bu değer ve altı)",
  "calib.liftOffHint": "Kalkış eşiğinden küçük olmalı (titreşimde açık-kapa olmasın).",
  "calib.liftDriveHint": "Direk kalkıkken hız bunun üstündeyse 'sürüşte direk' olarak sayılır. Yalnızca sayılır, hiçbir şey engellenmez.",
  "calib.noControl": "Bu ayarlar yalnızca ölçümün yorumlanmasını değiştirir. Hiçbiri aracı, direği veya immobilizeri etkilemez. Analog giriş aralığı {min}–{max} V.",
  "calib.saved": "{vehicle} kalibrasyonu kaydedildi.",
  "calib.issue.same_channel": "Akü ve direk aynı analog girişi kullanamaz.",
  "calib.issue.bat_scale": "Çarpan 0 olamaz ve −1000 ile 1000 arasında olmalı.",
  "calib.issue.bat_offset": "Sabit −1000 ile 1000 arasında olmalı.",
  "calib.issue.bat_low_v": "Eşik 5 ile 120 V arasında olmalı.",
  "calib.issue.lift_scale": "Çarpan 0 olamaz ve −1000 ile 1000 arasında olmalı.",
  "calib.issue.lift_offset": "Sabit −1000 ile 1000 arasında olmalı.",
  "calib.issue.lift_thresholds": "İki direk eşiği de girilmeli.",
  "calib.issue.lift_hysteresis": "'İndi' eşiği 'kalkıyor' eşiğinden küçük olmalı.",
  "calib.issue.lift_drive_kmh": "Hız eşiği 0,5 ile 30 km/sa arasında olmalı.",
  "calib.issue.charge_rise_v": "Artış 0,2 ile 20 V arasında olmalı.",
  "battery.title": "Akü raporu",
  "battery.subtitle": "Araç başına ölçülen akü gerilimi, düşük akü uyarıları ve gerilimden tahmin edilen şarjlar",
  "battery.slug": "aku",
  "battery.rangeTooLong": "Akü raporu en fazla 31 günü kapsar.",
  "battery.tooLarge": "Seçim çok büyük (araç × gün en fazla {max}). Saha veya araç seçerek daraltın.",
  "help.battery.topic": "Akü raporu nasıl hesaplanır?",
  "help.battery": "Gerilim, aracın kalibrasyonunda seçilen kaynaktan ölçülür (FTS akü modülü, gerilim bölücülü analog giriş veya doğrudan aküden besleme); kaynağı olmayan araç için gerilim gösterilmez. Şarj ölçülmez: kontak kapalıyken gerilimin şarj seviyesinin (2,25 V/hücre) üstünde kalmasından tahmin edilir. Düşük akü uyarısı yalnızca dinlenme hâlindeki ölçümlerle değerlendirilir; yük altındaki düşüşler uyarı üretmez.",
  "battery.sum.measured": "Ölçülen araç",
  "battery.sum.measuredValue": "{measured} / {total}",
  "battery.sum.charges": "Şarj (tahmini)",
  "battery.sum.chargeTime": "Şarj süresi (tahmini)",
  "battery.sum.opportunity": "Ara şarj (tahmini)",
  "battery.sum.lowAlarms": "Düşük akü uyarısı",
  "battery.voltage.title": "Gerilim (zaman içinde)",
  "battery.voltage.label": "{vehicle} akü gerilimi, en düşük {min} V, en yüksek {max} V",
  "battery.voltage.legend": "Çizgi: 15 dk ortalama ölçülen gerilim · bant: en düşük–en yüksek · gölge: tahmini şarj (açık renk ara şarj) · kesik çizgi: düşük akü eşiği · kaynak: {source}",
  "battery.voltage.none": "Gösterilecek ölçüm yok",
  "battery.voltage.noneBody": "Bu seçimdeki araçların akü kaynağı yok veya dönemde ölçüm gelmedi. Kaynak, aracın 'Analog girişler ve kalibrasyon' panelinden seçilir.",
  "battery.chart.title": "Araç başına şarj süresi (tahmini, gerilimden)",
  "battery.chart.full": "Uzun şarj",
  "battery.chart.opportunity": "Ara şarj",
  "battery.chart.total": "Toplam",
  "battery.chart.summary": "En uzun tahmini şarj süresi {vehicle}: {h} sa.",
  "battery.chart.note": "Şarj süreleri ölçülmez, gerilimden tahmin edilir. Akü kaynağı olmayan araçlar grafikte yoktur.",
  "battery.table.title": "Araçlar",
  "battery.col.source": "Kaynak",
  "battery.col.readings": "Ölçüm",
  "battery.col.min": "En düşük (V)",
  "battery.col.avg": "Ortalama (V)",
  "battery.col.max": "En yüksek (V)",
  "battery.col.lowV": "Eşik (V)",
  "battery.col.lowReadings": "Eşik altı ölçüm",
  "battery.col.lowAlarms": "Uyarı",
  "battery.col.charges": "Şarj (tahmini)",
  "battery.col.chargeTime": "Şarj süresi (tahmini)",
  "battery.col.opportunity": "Ara şarj (tahmini)",
  "battery.col.start": "Başlangıç",
  "battery.col.end": "Bitiş",
  "battery.col.duration": "Süre",
  "battery.col.startV": "Başlangıç gerilimi (V)",
  "battery.col.endV": "Bitiş (V)",
  "battery.col.peakV": "En yüksek (V)",
  "battery.col.kind": "Tür (tahmini)",
  "battery.kind.full": "Uzun şarj (≥ {min} dk)",
  "battery.kind.opportunity": "Ara şarj (< {min} dk)",
  "battery.kind.open": "sürüyor",
  "battery.noSource": "Akü kaynağı yok",
  "battery.noData": "Ölçüm yok",
  "battery.noSourceRow": "Bu araçta akü ölçülmüyor; besleme gerilimi akü gerilimi olarak gösterilmez.",
  "battery.noDataRow": "Dönemde akü ölçümü yok: aracın akü modülü veya kalibre edilmiş akü girişi yoksa gerilim gösterilmez (besleme gerilimi akü gerilimi olarak gösterilmez).",
  "battery.sessions.title": "Şarj oturumları (tahmini, gerilimden çıkarıldı)",
  "battery.sessions.none": "Dönemde şarj tahmin edilmedi.",
  "battery.sheet.vehicles": "Araçlar",
  "battery.sheet.sessions": "Şarjlar (tahmini)",
  "battery.opp.title": "Ara şarj (fırsat şarjı, tahmini)",
  "battery.opp.intro": "{min} dakikadan kısa şarjlar, örneğin mola sırasında yapılan takviye şarjlar.",
  "battery.opp.none": "Dönemde ara şarj yok.",
  "battery.opp.chartTitle": "Tahmini ara şarjların başladığı saat",
  "battery.opp.hour": "Saat",
  "battery.opp.hourTitle": "{h}:00–{h}:59",
  "battery.opp.summary": "Toplam {count} tahmini ara şarj.",
  "battery.rules": "Şarj tahmini (akım ölçülmez): kontak kapalıyken {n} ölçümlük medyanla yumuşatılmış gerilim şarj seviyesine ({perCell} V/hücre, araç kalibrasyonunda değiştirilebilir) ulaşıp {hold} dakika kalınca başlar; {end} V/hücrenin altına düşünce, kontak açılınca veya 15 dakikadan uzun veri boşluğunda biter. Dinlenme sonrası toparlanma ve tek ölçümlük sıçramalar sayılmaz; seviye bilinmiyorsa kontak kapandıktan {settle} dakika sonraki taban kullanılır. {min} dakikadan kısa olanlar sayılmaz, {opp} dakikadan kısa olanlar ara şarjdır.",
  "battery.measuredOnly": "Gerilim değerleri ölçülmüş değerlerdir (uydurma gerilim yoktur); şarj oturumları ve süreleri gerilimden yapılan tahminlerdir.",
  "lift.title": "Direk (asansör) raporu",
  "lift.subtitle": "Kaldırma sayısı, kaldırma süresi ve sürüş sırasında direk kalkık",
  "lift.slug": "direk",
  "lift.rangeTooLong": "Direk raporu en fazla 31 günü kapsar.",
  "help.lift.topic": "Direk raporu nasıl hesaplanır?",
  "help.lift": "Direk sensörünün analog sinyali aracın kalibrasyonundaki iki eşikle değerlendirilir: 'kalkıyor' eşiğinde başlar, 'indi' eşiğinde biter (aradaki dalgalanma sayılmaz). Direk kalkıkken hız eşiğin üstündeyse 'sürüşte direk' sayılır. Yalnızca sayılır; FTS hiçbir şeyi engellemez.",
  "lift.kvkkNote": "Operatör bazında görünüm kişisel veridir (KVKK): yalnızca İSG eğitimi amacıyla kullanılır. Göremediğiniz operatörler yalnızca sayı olarak görünür.",
  "lift.purpose": "İSG eğitimi ve iş planlama",
  "lift.sum.lifts": "Kaldırma",
  "lift.sum.liftTime": "Kaldırma süresi",
  "lift.sum.whileDriving": "Sürüşte direk",
  "lift.sum.whileDrivingTime": "Sürüşte direk süresi",
  "lift.chart.title": "Kaldırmalar",
  "lift.chart.standing": "Dururken",
  "lift.chart.driving": "Sürüşte",
  "lift.chart.summary": "Toplam {lifts} kaldırma, {driving} tanesi sürüş sırasında.",
  "lift.chart.note": "Sürüşte direk yalnızca sayılır, engellenmez.",
  "lift.col.lifts": "Kaldırma",
  "lift.col.liftTime": "Süre",
  "lift.col.whileDriving": "Sürüşte",
  "lift.col.whileDrivingTime": "Sürüşte süre",
  "lift.unconfigured": "{count} araçta direk sensörü tanımlı değil, bu araçlar raporda yok: {vehicles}",
  "lift.rules": "Eşikler ve hız aracın kalibrasyonundan gelir. Veride 2 dakikadan uzun boşluk kaldırmayı son ölçümde bitirir. Ölçüm sıklığı ünitenin gönderim aralığıyla sınırlıdır.",
  "eco.title": "Eko sürüş olayları",
  "eco.slug": "eko-surus",
  "eco.source": "Kaynak",
  "eco.sourceShort": "ivmeölçerli üniteler",
  "eco.sourceValue": "Teltonika ivmeölçeri ({measured} / {total} araç).",
  "eco.sourceNote": "m-DVR ve FTS ünitesi bu olayları ölçmez; bu araçların sıfırı 'olay yok' anlamına gelmez, karşılaştırmayın.",
  "eco.notMeasured": "Ölçülmeyen araçlar: {vehicles}.",
  "eco.noSource": "Bu seçimde eko sürüş ölçen araç yok",
  "eco.noSourceBody": "Eko sürüş olayları yalnızca Teltonika ünitelerinden gelir.",
  "eco.none": "Dönemde eko sürüş olayı yok.",
  "eco.sum.total": "Toplam olay",
  "eco.type.harsh_accel": "Sert hızlanma",
  "eco.type.harsh_brake": "Sert fren",
  "eco.type.harsh_corner": "Sert dönüş",
  "eco.chart.title": "Eko sürüş olayları",
  "eco.chart.summary": "Toplam {total} olay.",
  "eco.table.title": "Sayılar",
  "eco.col.total": "Toplam",
  "eco.col.maxG": "En yüksek (g)",
  "eco.col.at": "Zaman",
  "eco.col.type": "Olay",
  "eco.col.g": "Değer (g)",
  "eco.col.lat": "Enlem",
  "eco.col.lon": "Boylam",
  "eco.map.title": "Haritada olaylar",
  "eco.map.label": "Eko sürüş olaylarının konumları",
  "eco.list.title": "Olay listesi",
  "eco.list.showAll": "Tümünü göster ({count})",
  "eco.list.truncated": "Liste ilk {max} olayla sınırlı.",
  "eco.sheet.counts": "Eko sayılar",
  "eco.sheet.events": "Eko olaylar",
  "tct.wiring.title": "İmmobilizer rölesi bağlantısı",
  "tct.wiring.body": "DOUT1 rölesi yalnızca marş (start) devresine bağlanır; kontak, motor veya sürüş beslemesine bağlanmaz. Kontrol: araç çalışırken röle bırakılsa bile araç çalışmaya devam etmeli; yalnızca bir sonraki kartsız çalıştırma engellenmeli.",
  "calib.chargeV": "Şarj seviyesi (tahmin için)",
  "calib.chargeVHint": "Kontak kapalıyken bu gerilimin üstü şarj sayılır. Boş = aracın nominal geriliminden 2,25 V/hücre.",
  "calib.chargeVHintNominal": "Boş = {nominal} V akü için {v} V (2,25 V/hücre). Lityum akülerde üreticinin şarj gerilimine göre girin.",
  "calib.chargeVUnknown": "Bilinmiyor (nominal gerilim yok): yedek kural, dinlenmeden sonra {rise} V artış",
  "calib.chargeVDerived": "nominal gerilimden",
  "calib.issue.charge_v": "Şarj seviyesi 5 ile 120 V arasında olmalı.",
  "eco.list.hidden": "Göremediğiniz operatörlere ait {count} olay sayılara dahildir; zamanı ve konumu listede ve haritada gösterilmez (KVKK).",
  // ADR 0033: KYS forms FR-11 / FR-12.
  "nav.group.kys": "KYS formları",
  "nav.kysFr12": "FR-12 Günlük forklift kontrol",
  "nav.kysFr11": "FR-11 Envanter ve bakım",
  "error.already_approved": "Bu form zaten onaylanmış.",
  "error.invalid_maintenance": "Bakım bilgisi geçersiz. Periyot 1–60 ay olmalı, tarih ileri bir gün olamaz, not en fazla 200 karakter.",
  "error.invalid_form": "Form bilgisi geçersiz. Doküman kodu büyük harf, rakam ve tire içermeli; revizyon ve başlık zorunludur.",
  "kys.template.library": "KYS formu",
  "kys.form.code": "Doküman Kodu",
  "kys.form.revision": "Revizyon No",
  "kys.form.revisionDate": "Rev. Tarih",
  "kys.form.label": "Form / revizyon",
  "kys.export.pdfAll": "PDF (dönemin formları)",
  "kys.export.pdfOne": "Bu formu PDF indir",
  "kys.export.pdfForm": "PDF (form)",
  "kys.fr12.title": "FR-12 Günlük forklift kontrol",
  "kys.fr12.subtitle": "Vardiya öncesi kontrol listesinin KYS FR-12 formu olarak kayıtları: belge numarası, onay ve kâğıt form düzeninde çıktı.",
  "kys.fr12.formTitle": "Form",
  "kys.fr12.closeForm": "Formu kapat",
  "kys.fr12.notFound": "Form bulunamadı ya da görme yetkiniz yok.",
  "kys.fr12.count": "{count} form",
  "kys.fr12.open": "Formu aç",
  "kys.fr12.openForm": "FR-12 formunu aç",
  "kys.fr12.footnote": "Yalnızca KYS FR-12 şablonuyla doldurulan kontroller burada listelenir. Operatör adı formda yer almaz; kart kaydıyla belirlenip belirlenmediği yazılır.",
  "kys.fr12.tableHeading": "Kontrol listesi",
  "kys.fr12.field.date": "Tarih",
  "kys.fr12.field.documentNo": "Belge No",
  "kys.fr12.field.vehicle": "Forklift No / Model",
  "kys.fr12.field.site": "Saha",
  "kys.fr12.field.shift": "Vardiya",
  "kys.fr12.field.result": "Sonuç",
  "kys.fr12.col.item": "Kontrol maddesi",
  "kys.fr12.col.ok": "Uygun",
  "kys.fr12.col.notOk": "Uygun değil",
  "kys.fr12.col.note": "Açıklama",
  "kys.fr12.col.code": "No",
  "kys.fr12.col.answer": "Yanıt",
  "kys.fr12.col.operatorKnown": "Operatör belirlendi",
  "kys.fr12.col.approvedAt": "Onay zamanı",
  "kys.fr12.mark": "X",
  "kys.fr12.na": "Yok (uygulanmaz)",
  "kys.fr12.sign.operator": "F. Operatör",
  "kys.fr12.sign.approver": "Onaylayan",
  "kys.fr12.operatorKnown": "Kart kaydıyla belirlendi",
  "kys.fr12.operatorUnknown": "Operatör belirlenemedi",
  "kys.fr12.approvalPending": "Onay bekliyor",
  "kys.fr12.approve": "Onayla",
  "kys.fr12.approveTitle": "Formu onayla",
  "kys.fr12.approveText": "Form, sizin rolünüz ve şu anki zamanla onaylanacak. Onay geri alınamaz. Sonuç ve arıza kayıtları değişmez.",
  "kys.fr12.approved": "Form onaylandı.",
  "kys.fr12.noLock": "Bu form yalnızca kayıttır; sistem aracı kilitlemez veya durdurmaz.",
  "kys.fr11.title": "FR-11 Envanter ve bakım takibi",
  "kys.fr11.subtitle": "Araçların bakım periyodu, sorumlu rolü, son ve sonraki bakım ile yıllık periyodik kontrol tarihleri.",
  "kys.fr11.count": "{count} ekipman",
  "kys.fr11.empty": "Bu kapsamda ekipman yok.",
  "kys.fr11.footnote": "Sonraki tarihler son kayıttan hesaplanır: bakım periyot kadar, periyodik kontrol 12 ay sonra. Açık kritik arızası olan araç “Bakım gerekli” görünür; araç kilitlenmez.",
  "kys.fr11.field.date": "Tarih",
  "kys.fr11.col.no": "Ekipman No",
  "kys.fr11.col.name": "Ekipman adı",
  "kys.fr11.col.model": "Marka / Model",
  "kys.fr11.col.serial": "Seri No",
  "kys.fr11.col.location": "Konum",
  "kys.fr11.col.responsible": "Sorumlu (rol)",
  "kys.fr11.col.interval": "Bakım periyodu",
  "kys.fr11.col.intervalMonths": "Bakım periyodu (ay)",
  "kys.fr11.col.lastPeriodic": "Son bakım tarihi",
  "kys.fr11.col.nextPeriodic": "Sonraki bakım",
  "kys.fr11.col.lastInspection": "Periyodik kontrol (yıllık)",
  "kys.fr11.col.nextInspection": "Sonraki periyodik kontrol",
  "kys.fr11.col.status": "Durum",
  "kys.fr11.months": "{n} ay",
  "kys.fr11.last": "son",
  "kys.fr11.actions": "İşlemler",
  "kys.fr11.records": "Bakım kayıtları",
  "kys.fr11.plan": "Plan",
  "kys.fr11.planTitle": "{vehicle} bakım planı",
  "kys.fr11.planSaved": "Bakım planı kaydedildi.",
  "kys.fr11.intervalHint": "1–60 ay. Boş bırakılırsa sonraki bakım tarihi hesaplanmaz.",
  "kys.fr11.intervalInvalid": "Periyot 1 ile 60 ay arasında olmalı.",
  "kys.fr11.roleHint": "Kişi adı değil, rol seçilir.",
  "kys.fr11.recordsTitle": "{vehicle} bakım kayıtları",
  "kys.fr11.recordSaved": "Bakım kaydı eklendi.",
  "kys.fr11.addRecord": "Kaydı ekle",
  "kys.fr11.kind": "Kayıt türü",
  "kys.fr11.doneOn": "Yapıldığı tarih",
  "kys.fr11.note": "Not",
  "kys.fr11.noteHint": "Yapılan iş (en fazla 200 karakter). Kişi adı yazmayın.",
  "kys.fr11.history": "Geçmiş",
  "kys.fr11.noRecords": "Henüz bakım kaydı yok.",
  "kys.fr11.purposeTitle": "1. Amaç",
  "kys.fr11.purpose": "Bu form, işletmede kullanılan ekipmanların envanterinin, bakım tarihçesinin ve sorumlularının kayıt altına alınmasını sağlamak için kullanılır.",
  "kys.fr11.scopeTitle": "2. Kapsam",
  "kys.fr11.scope": "Bu çıktı, Forklift Takip Sistemi'nde kayıtlı araçları kapsar.",
  "kys.fr11.preparedBy": "Hazırlayan",
  "kys.fr11.status.inactive": "Kullanım dışı",
  "kys.fr11.status.maintenance_required": "Bakım gerekli",
  "kys.fr11.status.overdue": "Süresi geçti",
  "kys.fr11.status.due_soon": "Yaklaşıyor",
  "kys.fr11.status.ok": "Güncel",
  "kys.fr11.status.unknown": "Kayıt yok",
  "kys.kind.periodic": "Periyodik bakım",
  "kys.kind.annual_inspection": "Yıllık periyodik kontrol",
  "kys.kind.repair": "Arıza onarımı",
  "kys.mrole.operations_chief": "Operasyon şefi",
  "kys.mrole.workshop_chief": "Atölye şefi",
  "kys.mrole.technician": "Teknisyen",
  "kys.mrole.fleet_manager": "Filo yöneticisi",
  "kys.mrole.safety_officer": "İSG sorumlusu",
  "kys.mrole.order_management": "Sipariş yönetimi",
  "kys.mrole.external_service": "Dış bakım firması",
  "kys.fr11.formNote": "Sorumlu sütununda kişi adı değil rol yer alır. Sonraki tarihler Forklift Takip Sistemi'ndeki son kayıttan hesaplanmıştır.",
  "kys.form.controlledDefault": "Bu doküman, kuruluşun kalite yönetim sistemi kapsamında kontrollü dokümandır.",
  "kys.fr11.status.no_inspection": "Yıllık kontrol kaydı yok",
  "kys.fr11.correct": "Düzelt",
  "kys.fr11.correctTitle": "{date} kaydını düzelt",
  "kys.fr11.correcting": "Düzeltilen kayıt: {date} · {kind}. Eski kayıt silinmez, geçersiz olarak işaretlenir.",
  "kys.fr11.cancelCorrection": "Düzeltmeyi bırak",
  "kys.fr11.saveCorrection": "Düzeltmeyi kaydet",
  "kys.fr11.voidReason": "Düzeltme nedeni",
  "kys.fr11.voidReasonHint": "Zorunlu, en fazla 200 karakter. Kişi adı yazmayın.",
  "kys.fr11.voided": "Geçersiz",
  "kys.fr11.correctionOf": "Düzeltme · neden: {reason}",
  "kys.fr11.noDelete": "Bakım kayıtları silinmez. Yanlış bir kayıt “Düzelt” ile yeni bir kayıtla geçersiz kılınır; ikisi de geçmişte kalır.",
  "kys.footer.button": "Form altbilgisi",
  "kys.footer.title": "Form altbilgisi",
  "kys.footer.label": "Kontrollü doküman satırı",
  "kys.footer.hint": "Form PDF'lerinin altında yazar. Boş bırakılırsa genel bir cümle kullanılır: “{default}”",
  "kys.footer.saved": "Form altbilgisi kaydedildi.",
} as const satisfies Record<string, string>;

export type MessageKey = keyof typeof tr;
export type Messages = Record<MessageKey, string>;
